webpackJsonp([114276838955818,60335399758886],{

/***/ 92:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(194);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(92);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(147);

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(6);
	var settle = __webpack_require__(153);
	var buildURL = __webpack_require__(156);
	var parseHeaders = __webpack_require__(162);
	var isURLSameOrigin = __webpack_require__(160);
	var createError = __webpack_require__(101);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(155);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(158);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(6);
	var bind = __webpack_require__(102);
	var Axios = __webpack_require__(149);
	var defaults = __webpack_require__(51);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(99);
	axios.CancelToken = __webpack_require__(148);
	axios.isCancel = __webpack_require__(100);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(163);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),

/***/ 99:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(99);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),

/***/ 100:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(51);
	var utils = __webpack_require__(6);
	var InterceptorManager = __webpack_require__(150);
	var dispatchRequest = __webpack_require__(151);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(6);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(152);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(6);
	var transformData = __webpack_require__(154);
	var isCancel = __webpack_require__(100);
	var defaults = __webpack_require__(51);
	var isAbsoluteURL = __webpack_require__(159);
	var combineURLs = __webpack_require__(157);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),

/***/ 152:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(101);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(6);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(6);
	var normalizeHeaderName = __webpack_require__(161);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(98);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(98);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),

/***/ 155:
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(6);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),

/***/ 157:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(6);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),

/***/ 159:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(6);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(6);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(6);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),

/***/ 163:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(102);
	var isBuffer = __webpack_require__(338);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),

/***/ 216:
/***/ (function(module, exports) {

	/*!
	 * cookie
	 * Copyright(c) 2012-2014 Roman Shtylman
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.parse = parse;
	exports.serialize = serialize;
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var decode = decodeURIComponent;
	var encode = encodeURIComponent;
	var pairSplitRegExp = /; */;
	
	/**
	 * RegExp to match field-content in RFC 7230 sec 3.2
	 *
	 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
	 * field-vchar   = VCHAR / obs-text
	 * obs-text      = %x80-FF
	 */
	
	var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
	
	/**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [options]
	 * @return {object}
	 * @public
	 */
	
	function parse(str, options) {
	  if (typeof str !== 'string') {
	    throw new TypeError('argument str must be a string');
	  }
	
	  var obj = {}
	  var opt = options || {};
	  var pairs = str.split(pairSplitRegExp);
	  var dec = opt.decode || decode;
	
	  for (var i = 0; i < pairs.length; i++) {
	    var pair = pairs[i];
	    var eq_idx = pair.indexOf('=');
	
	    // skip things that don't look like key=value
	    if (eq_idx < 0) {
	      continue;
	    }
	
	    var key = pair.substr(0, eq_idx).trim()
	    var val = pair.substr(++eq_idx, pair.length).trim();
	
	    // quoted values
	    if ('"' == val[0]) {
	      val = val.slice(1, -1);
	    }
	
	    // only assign once
	    if (undefined == obj[key]) {
	      obj[key] = tryDecode(val, dec);
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Serialize data into a cookie header.
	 *
	 * Serialize the a name value pair into a cookie string suitable for
	 * http headers. An optional options object specified cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [options]
	 * @return {string}
	 * @public
	 */
	
	function serialize(name, val, options) {
	  var opt = options || {};
	  var enc = opt.encode || encode;
	
	  if (typeof enc !== 'function') {
	    throw new TypeError('option encode is invalid');
	  }
	
	  if (!fieldContentRegExp.test(name)) {
	    throw new TypeError('argument name is invalid');
	  }
	
	  var value = enc(val);
	
	  if (value && !fieldContentRegExp.test(value)) {
	    throw new TypeError('argument val is invalid');
	  }
	
	  var str = name + '=' + value;
	
	  if (null != opt.maxAge) {
	    var maxAge = opt.maxAge - 0;
	    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
	    str += '; Max-Age=' + Math.floor(maxAge);
	  }
	
	  if (opt.domain) {
	    if (!fieldContentRegExp.test(opt.domain)) {
	      throw new TypeError('option domain is invalid');
	    }
	
	    str += '; Domain=' + opt.domain;
	  }
	
	  if (opt.path) {
	    if (!fieldContentRegExp.test(opt.path)) {
	      throw new TypeError('option path is invalid');
	    }
	
	    str += '; Path=' + opt.path;
	  }
	
	  if (opt.expires) {
	    if (typeof opt.expires.toUTCString !== 'function') {
	      throw new TypeError('option expires is invalid');
	    }
	
	    str += '; Expires=' + opt.expires.toUTCString();
	  }
	
	  if (opt.httpOnly) {
	    str += '; HttpOnly';
	  }
	
	  if (opt.secure) {
	    str += '; Secure';
	  }
	
	  if (opt.sameSite) {
	    var sameSite = typeof opt.sameSite === 'string'
	      ? opt.sameSite.toLowerCase() : opt.sameSite;
	
	    switch (sameSite) {
	      case true:
	        str += '; SameSite=Strict';
	        break;
	      case 'lax':
	        str += '; SameSite=Lax';
	        break;
	      case 'strict':
	        str += '; SameSite=Strict';
	        break;
	      default:
	        throw new TypeError('option sameSite is invalid');
	    }
	  }
	
	  return str;
	}
	
	/**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */
	
	function tryDecode(str, decode) {
	  try {
	    return decode(str);
	  } catch (e) {
	    return str;
	  }
	}


/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(287);
	var isArguments = __webpack_require__(286);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 286:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 287:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 338:
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(380);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(285);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(362);
	
	var _HelmetConstants = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(49);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(294);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(385);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 385:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cookie = __webpack_require__(216);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _objectAssign = __webpack_require__(49);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _utils = __webpack_require__(388);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Cookies = function () {
	  function Cookies(cookies, hooks) {
	    _classCallCheck(this, Cookies);
	
	    this.cookies = parseCookies(cookies);
	    this.hooks = hooks;
	    this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
	  }
	
	  _createClass(Cookies, [{
	    key: '_updateBrowserValues',
	    value: function _updateBrowserValues() {
	      if (!this.HAS_DOCUMENT_COOKIE) {
	        return;
	      }
	
	      this.cookies = _cookie2.default.parse(document.cookie);
	    }
	  }, {
	    key: 'get',
	    value: function get(name) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this._updateBrowserValues();
	      return readCookie(this.cookies[name], options);
	    }
	  }, {
	    key: 'getAll',
	    value: function getAll() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      this._updateBrowserValues();
	      var result = {};
	
	      for (var name in this.cookies) {
	        result[name] = readCookie(this.cookies[name], options);
	      }
	
	      return result;
	    }
	  }, {
	    key: 'set',
	    value: function set(name, value, options) {
	      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	        value = JSON.stringify(value);
	      }
	
	      if (this.hooks && this.hooks.onSet) {
	        this.hooks.onSet(name, value, options);
	      }
	
	      this.cookies[name] = value;
	
	      if (this.HAS_DOCUMENT_COOKIE) {
	        document.cookie = _cookie2.default.serialize(name, value, options);
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove(name, options) {
	      var finalOptions = options = (0, _objectAssign2.default)({}, options, {
	        expires: new Date(1970, 1, 1, 0, 0, 1),
	        maxAge: 0
	      });
	
	      if (this.hooks && this.hooks.onRemove) {
	        this.hooks.onRemove(name, finalOptions);
	      }
	
	      delete this.cookies[name];
	
	      if (this.HAS_DOCUMENT_COOKIE) {
	        document.cookie = _cookie2.default.serialize(name, '', finalOptions);
	      }
	    }
	  }]);
	
	  return Cookies;
	}();
	
	exports.default = Cookies;
	
	
	function parseCookies(cookies) {
	  if (typeof cookies === 'string') {
	    return _cookie2.default.parse(cookies);
	  } else if ((typeof cookies === 'undefined' ? 'undefined' : _typeof(cookies)) === 'object' && cookies !== null) {
	    return cookies;
	  } else {
	    return {};
	  }
	}
	
	function isParsingCookie(value, doNotParse) {
	  if (typeof doNotParse === 'undefined') {
	    // We guess if the cookie start with { or [, it has been serialized
	    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
	  }
	
	  return !doNotParse;
	}
	
	function readCookie(value) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (isParsingCookie(value, options.doNotParse)) {
	    try {
	      return JSON.parse(value);
	    } catch (e) {
	      // At least we tried
	    }
	  }
	
	  return value;
	}
	module.exports = exports['default'];

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cookies = __webpack_require__(386);
	
	var _Cookies2 = _interopRequireDefault(_Cookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Cookies2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 388:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.hasDocumentCookie = hasDocumentCookie;
	exports.cleanCookies = cleanCookies;
	// Can we get/set cookies on document.cookie?
	
	function hasDocumentCookie() {
	  return (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && typeof document.cookie === 'string';
	}
	
	//backwards compatibility
	var HAS_DOCUMENT_COOKIE = exports.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
	
	function cleanCookies() {
	  document.cookie.split(';').forEach(function (c) {
	    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
	  });
	}

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/contactFormBackground.f1af142d.jpg";

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/contactInfoBackground.981aa255.jpg";

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ogImage.e14adeff.jpg";

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(36);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ButtonModule = __webpack_require__(86);
	
	var _ButtonModule2 = _interopRequireDefault(_ButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = function Button(props) {
	  var classes = [_ButtonModule2.default.button, _ButtonModule2.default[props.size], _ButtonModule2.default[props.color], props.text ? _ButtonModule2.default.text : null, props.inline ? _ButtonModule2.default.inline : null, props.disabled ? _ButtonModule2.default.disabled : null, props.loading ? _ButtonModule2.default.loading : null].join(' ');
	
	  if (props.render) {
	    switch (props.type) {
	      case 'anchor':
	        return _react2.default.createElement(
	          'a',
	          {
	            className: classes,
	            href: props.to,
	            onClick: props.onClick,
	            rel: props.target === '_blank' ? 'nofollow noopener' : null,
	            target: props.target
	          },
	          props.loading && _react2.default.createElement('div', { className: _ButtonModule2.default.loader }),
	          props.children
	        );
	
	      case 'link':
	        return _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            className: classes,
	            onClick: props.onClick,
	            to: props.to
	          },
	          props.loading && _react2.default.createElement('div', { className: _ButtonModule2.default.loader }),
	          props.children
	        );
	
	      default:
	        return _react2.default.createElement(
	          'button',
	          {
	            className: classes,
	            'data-role': props['data-role'],
	            disabled: props.disabled,
	            onClick: props.onClick,
	            type: props.type
	          },
	          props.loading && _react2.default.createElement('div', { className: _ButtonModule2.default.loader }),
	          props.children
	        );
	    }
	  }
	
	  return null;
	};
	
	Button.propTypes = {
	  color: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  inline: _propTypes2.default.bool,
	  loading: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  render: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  size: _propTypes2.default.string,
	  target: _propTypes2.default.string,
	  text: _propTypes2.default.bool,
	  to: _propTypes2.default.string,
	  type: _propTypes2.default.string
	};
	
	Button.defaultProps = {
	  color: 'default',
	  disabled: false,
	  loading: false,
	  render: true,
	  to: '/',
	  type: 'button'
	};
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"src-components-Button----Button-module---loader---2Z10x","before":"src-components-Button----Button-module---before---qmENX","after":"src-components-Button----Button-module---after---Plk0h","t-body":"src-components-Button----Button-module---t-body---27Yc1","t-small":"src-components-Button----Button-module---t-small---3GB4w","t-heading-xs":"src-components-Button----Button-module---t-heading-xs---2oggE","t-heading-s":"src-components-Button----Button-module---t-heading-s---3ZTU1","t-heading-m":"src-components-Button----Button-module---t-heading-m---1LD7a","t-heading-l":"src-components-Button----Button-module---t-heading-l---2hKwA","t-heading-xl":"src-components-Button----Button-module---t-heading-xl---1w63S","t-anchors":"src-components-Button----Button-module---t-anchors---hriac","t-buttons":"src-components-Button----Button-module---t-buttons---aovZh","button":"src-components-Button----Button-module---button---3zCJK","t-buttons-large":"src-components-Button----Button-module---t-buttons-large---20U-L","large":"src-components-Button----Button-module---large---2FBVs","t-formLabel":"src-components-Button----Button-module---t-formLabel---2PGiX","t-formHelper":"src-components-Button----Button-module---t-formHelper---330nk","t-formInput":"src-components-Button----Button-module---t-formInput---hmcW1","t-tableHeading":"src-components-Button----Button-module---t-tableHeading---2IGfJ","t-tableBody":"src-components-Button----Button-module---t-tableBody---mez5D","t-opaque":"src-components-Button----Button-module---t-opaque---3C55D","t-bold":"src-components-Button----Button-module---t-bold---1Q25R","t-italic":"src-components-Button----Button-module---t-italic---A7lQz","default":"src-components-Button----Button-module---default---2qZOn","text":"src-components-Button----Button-module---text---1P8Ig","confirm":"src-components-Button----Button-module---confirm---3hxrC","cancel":"src-components-Button----Button-module---cancel---2cAPw","inline":"src-components-Button----Button-module---inline---2j4bF","small":"src-components-Button----Button-module---small---KnqJd","disabled":"src-components-Button----Button-module---disabled---2t4w_","loading":"src-components-Button----Button-module---loading---olGuc","slideInTop":"src-components-Button----Button-module---slideInTop---3l0IE","slideInTopMild":"src-components-Button----Button-module---slideInTopMild---d6Q95","slideInBottom":"src-components-Button----Button-module---slideInBottom---1yjcf","slideInBottomMild":"src-components-Button----Button-module---slideInBottomMild---1ooY3","slideOutTop":"src-components-Button----Button-module---slideOutTop---2QZjY","slideOutTopMild":"src-components-Button----Button-module---slideOutTopMild---2sNx1","slideOutBottom":"src-components-Button----Button-module---slideOutBottom---3x-ig","slideOutBottomMild":"src-components-Button----Button-module---slideOutBottomMild---1-Hoa","shake-horizontal":"src-components-Button----Button-module---shake-horizontal---1ZVqj"};

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Button = __webpack_require__(53);
	
	var _Button2 = _interopRequireDefault(_Button);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Button2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(26);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ContentBlock = __webpack_require__(10);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	var _Icon = __webpack_require__(27);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _localization = __webpack_require__(174);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	var _common = __webpack_require__(28);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _CTAModule = __webpack_require__(295);
	
	var _CTAModule2 = _interopRequireDefault(_CTAModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CTA = function CTA(props) {
	  var language = props.language;
	
	
	  return _react2.default.createElement(
	    _ContentBlock2.default,
	    { center: true },
	    _react2.default.createElement(
	      'h2',
	      { className: _CTAModule2.default.title },
	      _localization2.default[language].title
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      { type: 'anchor', size: 'large', inline: true, to: _common2.default[language].bookUrl },
	      _localization2.default[language].button,
	      ' \xBB'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: _CTAModule2.default.shareText },
	      _localization2.default[language].shareText
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _CTAModule2.default.shareLinks },
	      _react2.default.createElement(
	        'a',
	        { href: _localization2.default[language].shareLinks.facebook, target: '_blank', rel: 'nofollow noopener', className: _CTAModule2.default.shareLink },
	        _react2.default.createElement(_Icon2.default, { type: 'facebook', size: 32 })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: _localization2.default[language].shareLinks.twitter, target: '_blank', rel: 'nofollow noopener', className: _CTAModule2.default.shareLink },
	        _react2.default.createElement(_Icon2.default, { type: 'twitter', size: 32 })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: _localization2.default[language].shareLinks.whatsapp, target: '_blank', rel: 'nofollow noopener', className: _CTAModule2.default.shareLink },
	        _react2.default.createElement(_Icon2.default, { type: 'whatsapp', size: 32 })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: _localization2.default[language].shareLinks.mail, className: _CTAModule2.default.shareLink },
	        _react2.default.createElement(_Icon2.default, { type: 'mail', size: 32 })
	      )
	    )
	  );
	};
	
	CTA.propTypes = {
	  language: _propTypes2.default.string.isRequired
	};
	
	exports.default = CTA;
	module.exports = exports['default'];

/***/ }),

/***/ 295:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"src-components-CTA----CTA-module---loader---39d2g","before":"src-components-CTA----CTA-module---before---1ZV2z","after":"src-components-CTA----CTA-module---after---ZkIVO","t-body":"src-components-CTA----CTA-module---t-body---2Uk7Y","t-small":"src-components-CTA----CTA-module---t-small---23A4a","t-heading-xs":"src-components-CTA----CTA-module---t-heading-xs---39NBf","shareText":"src-components-CTA----CTA-module---shareText---oQWy_","t-heading-s":"src-components-CTA----CTA-module---t-heading-s---1aSC7","t-heading-m":"src-components-CTA----CTA-module---t-heading-m---moctu","t-heading-l":"src-components-CTA----CTA-module---t-heading-l---OA04S","t-heading-xl":"src-components-CTA----CTA-module---t-heading-xl---w-x1q","title":"src-components-CTA----CTA-module---title---2HPMO","t-anchors":"src-components-CTA----CTA-module---t-anchors---3IvMK","t-buttons":"src-components-CTA----CTA-module---t-buttons---3VkPj","t-buttons-large":"src-components-CTA----CTA-module---t-buttons-large---3Hfv-","t-formLabel":"src-components-CTA----CTA-module---t-formLabel---3s15O","t-formHelper":"src-components-CTA----CTA-module---t-formHelper---10vlO","t-formInput":"src-components-CTA----CTA-module---t-formInput---1PO3V","t-tableHeading":"src-components-CTA----CTA-module---t-tableHeading---1C5_Z","t-tableBody":"src-components-CTA----CTA-module---t-tableBody---1QxmI","t-opaque":"src-components-CTA----CTA-module---t-opaque---3sKBS","t-bold":"src-components-CTA----CTA-module---t-bold---2boc6","t-italic":"src-components-CTA----CTA-module---t-italic---V9WO1","shareLinks":"src-components-CTA----CTA-module---shareLinks---tJ9K3","shareLink":"src-components-CTA----CTA-module---shareLink---q7wth","slideInTop":"src-components-CTA----CTA-module---slideInTop---1ldP8","slideInTopMild":"src-components-CTA----CTA-module---slideInTopMild---3DJ0R","slideInBottom":"src-components-CTA----CTA-module---slideInBottom---2JvPT","slideInBottomMild":"src-components-CTA----CTA-module---slideInBottomMild---1J8V8","slideOutTop":"src-components-CTA----CTA-module---slideOutTop---3KZxs","slideOutTopMild":"src-components-CTA----CTA-module---slideOutTopMild---_S8TQ","slideOutBottom":"src-components-CTA----CTA-module---slideOutBottom---3Hyu5","slideOutBottomMild":"src-components-CTA----CTA-module---slideOutBottomMild---3dIcE","shake-horizontal":"src-components-CTA----CTA-module---shake-horizontal---3N0oO"};

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CTA = __webpack_require__(172);
	
	var _CTA2 = _interopRequireDefault(_CTA);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _CTA2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 174:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var localization = {
	  nl: {
	    title: 'Tot binnenkort in de Vulkaaneifel?',
	    button: 'Boek uw verblijf via Micazu',
	    shareText: 'Of deel met uw gezelschap',
	    shareLinks: {
	      facebook: 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.ferienhaus-vek.nl',
	      twitter: 'https://twitter.com/home?status=Ferienhaus%20Vulkaneifel%20Kopp%20-%20Een%20thuis,%20weg%20van%20huis,%20voor%20grote%20gezelschappen%20-%20https%3A//www.ferienhaus-vek.nl',
	      whatsapp: 'whatsapp://send?text=Ferienhaus Vulkaneifel Kopp - Een thuis, weg van huis, voor grote gezelschappen - https://www.ferienhaus-vek.nl',
	      mail: 'mailto:?subject=Ferienhaus%20Vulkaneifel%20Kopp&body=%5BEigen%20tekst%5D%0A%0AFerienhaus%20Vulkaneifel%20Kopp%0AEen%20thuis%2C%20weg%20van%20huis%2C%20voor%20grote%20gezelschappen%0Ahttps%3A%2F%2Fwww.ferienhaus-vek.nl'
	    }
	  },
	  de: {
	    title: 'Bis bald in der Vulkaneifel?',
	    button: 'Buchen Sie Ihren Aufenthalt mit Micazu',
	    shareText: 'Oder teile mit Ihre Freunden und Familie',
	    shareLinks: {
	      facebook: 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.ferienhaus-vek.de',
	      twitter: 'https://twitter.com/home?status=Ferienhaus%20Vulkaneifel%20Kopp%20-%20Ein%20zweites%20Zuhause%20f%C3%BCr%20gro%C3%9Fe%20Gruppen%20-%20https%3A//www.ferienhaus-vek.de',
	      whatsapp: 'whatsapp://send?text=Ferienhaus Vulkaneifel Kopp - Ein zweites Zuhause für große Gruppen - https://www.ferienhaus-vek.de',
	      mail: 'mailto:?subject=Ferienhaus%20Vulkaneifel%20Kopp&body=%5BEigene%20Nachricht%5D%0A%0AFerienhaus%20Vulkaneifel%20Kopp%0AEin%20zweites%20Zuhause%20f%C3%BCr%20gro%C3%9Fe%20Gruppen%0Ahttps%3A%2F%2Fwww.ferienhaus-vek.de'
	    }
	  },
	  en: {
	    title: 'See you soon in the Vulkaneifel?',
	    button: 'Book your stay through Micazu',
	    shareText: 'Or share with your friends and family',
	    shareLinks: {
	      facebook: 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.ferienhaus-vek.de',
	      twitter: 'https://twitter.com/home?status=Ferienhaus%20Vulkaneifel%20Kopp%20-%20A%20home%20away%20from%20home%20for%20large%20groups%20-%20https%3A//www.ferienhaus-vek.de',
	      whatsapp: 'whatsapp://send?text=Ferienhaus Vulkaneifel Kopp - A home away from home for large groups - https://www.ferienhaus-vek.de',
	      mail: 'mailto:?subject=Ferienhaus%20Vulkaneifel%20Kopp&body=%5BOwn%20message%5D%0A%0AFerienhaus%20Vulkaneifel%20Kopp%0AA%20home%20away%20from%20home%20for%20large%20groups%0Ahttps%3A%2F%2Fwww.ferienhaus-vek.de'
	    }
	  }
	};
	
	exports.default = localization;
	module.exports = exports['default'];

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axios = __webpack_require__(146);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Button = __webpack_require__(26);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _localization = __webpack_require__(177);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	var _ContactFormModule = __webpack_require__(296);
	
	var _ContactFormModule2 = _interopRequireDefault(_ContactFormModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactForm = function (_Component) {
	  _inherits(ContactForm, _Component);
	
	  function ContactForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ContactForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      errorMessage: null,
	      loading: false,
	      successMessage: null,
	      touched: false,
	      formData: {
	        name: '',
	        email: '',
	        message: ''
	      }
	    }, _this._handleChange = function (e) {
	      var _extends2;
	
	      var _e$target = e.target,
	          name = _e$target.name,
	          value = _e$target.value;
	
	      _this.setState({ formData: _extends({}, _this.state.formData, (_extends2 = {}, _extends2[name] = value, _extends2)) });
	    }, _this._handleSubmit = function (e) {
	      e.preventDefault();
	
	      _this.setState({
	        errorMessage: null,
	        successMessage: null
	      });
	
	      var formData = _this.state.formData;
	      var language = _this.props.language;
	      var _e$target$elements = e.target.elements,
	          ongewenst = _e$target$elements.ongewenst,
	          ongewenstalt = _e$target$elements.ongewenstalt;
	
	
	      if (!ongewenst.value && !ongewenstalt.value && e.target.checkValidity()) {
	        _axios2.default.post('https://staticmailer.pexel.nl/' + _localization2.default[language].form.id, formData).then(function () {
	          _this.setState({
	            successMessage: _localization2.default[language].feedback.success,
	            touched: false,
	            formData: _extends({}, _this.state.formData, {
	              name: '',
	              email: '',
	              message: ''
	            })
	          });
	        }).catch(function () {
	          _this.setState({
	            errorMessage: _localization2.default[language].feedback.genericError
	          });
	        });
	      }
	
	      return null;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ContactForm.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        errorMessage = _state.errorMessage,
	        successMessage = _state.successMessage,
	        touched = _state.touched,
	        _state$formData = _state.formData,
	        name = _state$formData.name,
	        email = _state$formData.email,
	        message = _state$formData.message;
	    var language = this.props.language;
	
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      errorMessage && _react2.default.createElement(
	        'div',
	        { className: _ContactFormModule2.default.feedbackError },
	        errorMessage
	      ),
	      successMessage && _react2.default.createElement(
	        'div',
	        { className: _ContactFormModule2.default.feedbackSuccess },
	        successMessage
	      ),
	      _react2.default.createElement(
	        'form',
	        {
	          onSubmit: function onSubmit(e) {
	            _this2._handleSubmit(e);
	          },
	          className: touched ? 'touched' : null
	        },
	        _react2.default.createElement(
	          'label',
	          { className: 'ongewenst' },
	          'Dit veld leeglaten / Leave this field empty / Dieses Feld leer lassen',
	          _react2.default.createElement('input', { type: 'text', name: 'ongewenst', tabIndex: '-1' })
	        ),
	        _react2.default.createElement('input', { type: 'hidden', name: 'ongewenstalt' }),
	        _react2.default.createElement(
	          'label',
	          null,
	          _localization2.default[language].form.labelName,
	          _react2.default.createElement('input', {
	            type: 'text',
	            name: 'name',
	            value: name,
	            onChange: this._handleChange,
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          _localization2.default[language].form.labelEmail,
	          _react2.default.createElement('input', {
	            type: 'email',
	            name: 'email',
	            value: email,
	            onChange: this._handleChange,
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          _localization2.default[language].form.labelMessage,
	          _react2.default.createElement('textarea', {
	            name: 'message',
	            value: message,
	            onChange: this._handleChange,
	            required: true
	          })
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            loading: this.state.loading,
	            size: 'large',
	            type: 'submit',
	            onClick: function onClick() {
	              _this2.setState({ touched: true });
	            }
	          },
	          _localization2.default[language].form.submit,
	          ' \xBB'
	        )
	      )
	    );
	  };
	
	  return ContactForm;
	}(_react.Component);
	
	ContactForm.propTypes = {
	  language: _propTypes2.default.string.isRequired
	};
	exports.default = ContactForm;
	module.exports = exports['default'];

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"src-components-ContactForm----ContactForm-module---loader---2VHqA","before":"src-components-ContactForm----ContactForm-module---before---2Ppem","after":"src-components-ContactForm----ContactForm-module---after---1fJGf","t-body":"src-components-ContactForm----ContactForm-module---t-body---24LrH","t-small":"src-components-ContactForm----ContactForm-module---t-small---2utBG","t-heading-xs":"src-components-ContactForm----ContactForm-module---t-heading-xs---1rVWO","t-heading-s":"src-components-ContactForm----ContactForm-module---t-heading-s---S9ZZz","t-heading-m":"src-components-ContactForm----ContactForm-module---t-heading-m---tRY8o","t-heading-l":"src-components-ContactForm----ContactForm-module---t-heading-l---1JGNo","t-heading-xl":"src-components-ContactForm----ContactForm-module---t-heading-xl---12QEm","t-anchors":"src-components-ContactForm----ContactForm-module---t-anchors---2fbEv","t-buttons":"src-components-ContactForm----ContactForm-module---t-buttons---2Qflk","t-buttons-large":"src-components-ContactForm----ContactForm-module---t-buttons-large---GGG9U","t-formLabel":"src-components-ContactForm----ContactForm-module---t-formLabel---2Le-u","t-formHelper":"src-components-ContactForm----ContactForm-module---t-formHelper---1M0eU","t-formInput":"src-components-ContactForm----ContactForm-module---t-formInput---obQsK","t-tableHeading":"src-components-ContactForm----ContactForm-module---t-tableHeading---kTgA2","t-tableBody":"src-components-ContactForm----ContactForm-module---t-tableBody---2XLwq","t-opaque":"src-components-ContactForm----ContactForm-module---t-opaque---15ghO","t-bold":"src-components-ContactForm----ContactForm-module---t-bold---2DILL","t-italic":"src-components-ContactForm----ContactForm-module---t-italic---11t7a","touched":"src-components-ContactForm----ContactForm-module---touched---25LXn","feedbackError":"src-components-ContactForm----ContactForm-module---feedbackError---2E1Ds","feedbackSuccess":"src-components-ContactForm----ContactForm-module---feedbackSuccess---3puBk","shake-horizontal":"src-components-ContactForm----ContactForm-module---shake-horizontal---2dTXJ","slideInTop":"src-components-ContactForm----ContactForm-module---slideInTop---2FSVD","slideInTopMild":"src-components-ContactForm----ContactForm-module---slideInTopMild---2Sj98","slideInBottom":"src-components-ContactForm----ContactForm-module---slideInBottom---nFQYy","slideInBottomMild":"src-components-ContactForm----ContactForm-module---slideInBottomMild---3ujYo","slideOutTop":"src-components-ContactForm----ContactForm-module---slideOutTop---SKy9-","slideOutTopMild":"src-components-ContactForm----ContactForm-module---slideOutTopMild---39Ie4","slideOutBottom":"src-components-ContactForm----ContactForm-module---slideOutBottom---1LRtt","slideOutBottomMild":"src-components-ContactForm----ContactForm-module---slideOutBottomMild---1mkq5"};

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ContactForm = __webpack_require__(175);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _ContactForm2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 177:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var localization = {
	  nl: {
	    form: {
	      labelName: 'Uw naam',
	      labelEmail: 'Uw e-mailadres',
	      labelMessage: 'Uw vraag of bericht',
	      submit: 'Verzenden',
	      id: 'PJyldOca3WLh'
	    },
	    feedback: {
	      genericError: 'Er is iets misgegaan, probeer het later nog eens.',
	      noName: 'Voer uw naam in.',
	      noEmail: 'Voer uw e-mailadres in.',
	      noMessage: 'Voer een bericht in.',
	      success: 'Uw bericht is verzonden!'
	    }
	  },
	  de: {
	    form: {
	      labelName: 'Ihre Name',
	      labelEmail: 'Ihre E-Mail-Adresse',
	      labelMessage: 'Ihre Frage oder Nachricht',
	      submit: 'Senden',
	      id: '0P5oG3fvfJPK'
	    },
	    feedback: {
	      genericError: 'Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut.',
	      noName: 'Geben Sie Ihre Name.',
	      noEmail: 'Geben Sie Ihre E-Mail-Adresse.',
	      noMessage: 'Geben Sie ein Nachricht.',
	      success: 'Ihre Nachricht wurde gesendet!'
	    }
	  },
	  en: {
	    form: {
	      labelName: 'Your name',
	      labelEmail: 'Your e-mailaddress',
	      labelMessage: 'Your question or message',
	      submit: 'Send',
	      id: 'Nk3P01nNa3mI'
	    },
	    feedback: {
	      genericError: 'An error has occurred, please try again later.',
	      noName: 'Enter your name.',
	      noEmail: 'Enter your e-mail address.',
	      noMessage: 'Enter a message.',
	      success: 'Your message has been sent!'
	    }
	  }
	};
	
	exports.default = localization;
	module.exports = exports['default'];

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _localization = __webpack_require__(181);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	var _CookieConsentModule = __webpack_require__(298);
	
	var _CookieConsentModule2 = _interopRequireDefault(_CookieConsentModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CookieConsent = function (_Component) {
	  _inherits(CookieConsent, _Component);
	
	  function CookieConsent() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CookieConsent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      cookieConsent: _this.props.cookies.get('COOKIECONSENT')
	    }, _this._setCookie = function (e) {
	      var date = new Date();
	      date.setFullYear(date.getFullYear() + 10);
	
	      _this.props.cookies.set('COOKIECONSENT', 'true', { path: '/', expires: date });
	      e.target.parentElement.classList.add(_CookieConsentModule2.default.consented);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CookieConsent.prototype.render = function render() {
	    var _this2 = this;
	
	    if (this.state.cookieConsent !== 'true') {
	      return _react2.default.createElement(
	        'div',
	        { className: _CookieConsentModule2.default.cookieConsent },
	        _react2.default.createElement(
	          'span',
	          { className: _CookieConsentModule2.default.innerText },
	          _localization2.default[this.props.language]
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: _CookieConsentModule2.default.innerButton, onClick: function onClick(e) {
	              _this2._setCookie(e);
	            } },
	          '\xD7'
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return CookieConsent;
	}(_react.Component);
	
	CookieConsent.propTypes = {
	  cookies: _propTypes2.default.object.isRequired,
	  language: _propTypes2.default.string
	};
	exports.default = CookieConsent;
	module.exports = exports['default'];

/***/ }),

/***/ 298:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"src-components-CookieConsent----CookieConsent-module---loader---3qzoI","before":"src-components-CookieConsent----CookieConsent-module---before---24eSa","after":"src-components-CookieConsent----CookieConsent-module---after---25sB_","t-body":"src-components-CookieConsent----CookieConsent-module---t-body---17daE","t-small":"src-components-CookieConsent----CookieConsent-module---t-small---28GpG","t-heading-xs":"src-components-CookieConsent----CookieConsent-module---t-heading-xs---1SqP3","t-heading-s":"src-components-CookieConsent----CookieConsent-module---t-heading-s---2p0A_","t-heading-m":"src-components-CookieConsent----CookieConsent-module---t-heading-m---10rVd","t-heading-l":"src-components-CookieConsent----CookieConsent-module---t-heading-l---2YX25","t-heading-xl":"src-components-CookieConsent----CookieConsent-module---t-heading-xl---1HrC1","t-anchors":"src-components-CookieConsent----CookieConsent-module---t-anchors---IcMn0","t-buttons":"src-components-CookieConsent----CookieConsent-module---t-buttons---tGQkN","t-buttons-large":"src-components-CookieConsent----CookieConsent-module---t-buttons-large---1evGN","t-formLabel":"src-components-CookieConsent----CookieConsent-module---t-formLabel---3YyYg","t-formHelper":"src-components-CookieConsent----CookieConsent-module---t-formHelper---2Ic6s","t-formInput":"src-components-CookieConsent----CookieConsent-module---t-formInput---3zAgl","t-tableHeading":"src-components-CookieConsent----CookieConsent-module---t-tableHeading---31Nr9","t-tableBody":"src-components-CookieConsent----CookieConsent-module---t-tableBody---31O1T","t-opaque":"src-components-CookieConsent----CookieConsent-module---t-opaque---1-KHY","t-bold":"src-components-CookieConsent----CookieConsent-module---t-bold---2ps3n","t-italic":"src-components-CookieConsent----CookieConsent-module---t-italic---1HGGd","cookieConsent":"src-components-CookieConsent----CookieConsent-module---cookieConsent---1xrE2","slideInBottom":"src-components-CookieConsent----CookieConsent-module---slideInBottom---303D3","consented":"src-components-CookieConsent----CookieConsent-module---consented---lY5Nj","slideOutBottom":"src-components-CookieConsent----CookieConsent-module---slideOutBottom----OeSh","innerText":"src-components-CookieConsent----CookieConsent-module---innerText---3X6U9","innerButton":"src-components-CookieConsent----CookieConsent-module---innerButton---Nj3gl","slideInTop":"src-components-CookieConsent----CookieConsent-module---slideInTop---1KFfy","slideInTopMild":"src-components-CookieConsent----CookieConsent-module---slideInTopMild---1f55Y","slideInBottomMild":"src-components-CookieConsent----CookieConsent-module---slideInBottomMild---14RVB","slideOutTop":"src-components-CookieConsent----CookieConsent-module---slideOutTop---2s-jL","slideOutTopMild":"src-components-CookieConsent----CookieConsent-module---slideOutTopMild---2Uov7","slideOutBottomMild":"src-components-CookieConsent----CookieConsent-module---slideOutBottomMild---2w-V0","shake-horizontal":"src-components-CookieConsent----CookieConsent-module---shake-horizontal---1MZPq"};

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CookieConsent = __webpack_require__(179);
	
	var _CookieConsent2 = _interopRequireDefault(_CookieConsent);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _CookieConsent2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 181:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var localization = {
	  de: 'Wir verwenden Cookies um Ihnen das bestmögliche Erlebnis auf unsere Webseite zu bieten. Durch die Weiternutzung dieser Website, geben Sie Ihre Einwilligung zur Verwendung von Cookies.',
	  en: 'We use cookies to give you the best possible experience on our website. By continiuing to browse this site, you give consent for cookies to be used.',
	  es: 'Usamos cookies para darte la mejor experiencia posible en nuestro sitio web. Si continúas navegando este sitio, otorgas tu consentimiento para el uso de cookies.',
	  fr: 'Nous utilisons des cookies pour vous offrir la meilleure expérience possible sur notre site web. En continuant à parcourir ce site, vous acceptez l’utilisation des cookies.',
	  nl: 'Wij gebruiken cookies om u de best mogelijke ervaring op onze website te bieden. Door verder gebruik van deze website, stemt u met het gebruik van deze cookies.'
	};
	
	exports.default = localization;
	module.exports = exports['default'];

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(36);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _navigation = __webpack_require__(105);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _FooterModule = __webpack_require__(300);
	
	var _FooterModule2 = _interopRequireDefault(_FooterModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	  var language = props.language;
	
	
	  var renderNavItems = function renderNavItems() {
	    return Object.keys(_navigation2.default).map(function (page) {
	      return _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          key: _navigation2.default[page][language],
	          to: '/' + _navigation2.default[page][language].toLowerCase().replace(' ', ''),
	          className: _FooterModule2.default.menuItem,
	          activeClassName: _FooterModule2.default.menuItemActive
	        },
	        _navigation2.default[page][language]
	      );
	    });
	  };
	
	  return _react2.default.createElement(
	    'footer',
	    { className: _FooterModule2.default.footer },
	    _react2.default.createElement(
	      'div',
	      { className: _FooterModule2.default.copyright },
	      '\xA9 ',
	      new Date().getFullYear(),
	      ' Ferienhaus Vulkaneifel Kopp'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _FooterModule2.default.menu },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          to: '/',
	          exact: true,
	          className: _FooterModule2.default.menuItem,
	          activeClassName: _FooterModule2.default.menuItemActive
	        },
	        'Home'
	      ),
	      renderNavItems()
	    )
	  );
	};
	
	Footer.propTypes = {
	  language: _propTypes2.default.string.isRequired
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 300:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"src-components-Footer----Footer-module---loader---2G1C3","before":"src-components-Footer----Footer-module---before---71m2k","after":"src-components-Footer----Footer-module---after---1pLSJ","t-body":"src-components-Footer----Footer-module---t-body---OYbJL","t-small":"src-components-Footer----Footer-module---t-small---1rzqc","t-heading-xs":"src-components-Footer----Footer-module---t-heading-xs---1XmFe","t-heading-s":"src-components-Footer----Footer-module---t-heading-s---28URs","t-heading-m":"src-components-Footer----Footer-module---t-heading-m---3iyYk","t-heading-l":"src-components-Footer----Footer-module---t-heading-l---1klh5","t-heading-xl":"src-components-Footer----Footer-module---t-heading-xl---2JXby","t-anchors":"src-components-Footer----Footer-module---t-anchors---Y5NBX","t-buttons":"src-components-Footer----Footer-module---t-buttons---37IRW","t-buttons-large":"src-components-Footer----Footer-module---t-buttons-large---1ptet","t-formLabel":"src-components-Footer----Footer-module---t-formLabel---5B_pA","t-formHelper":"src-components-Footer----Footer-module---t-formHelper---3p2Sw","t-formInput":"src-components-Footer----Footer-module---t-formInput---2VRTG","t-tableHeading":"src-components-Footer----Footer-module---t-tableHeading---Jz-eM","t-tableBody":"src-components-Footer----Footer-module---t-tableBody---39O2e","t-opaque":"src-components-Footer----Footer-module---t-opaque---25edC","t-bold":"src-components-Footer----Footer-module---t-bold---2Euki","t-italic":"src-components-Footer----Footer-module---t-italic---3_SsC","footer":"src-components-Footer----Footer-module---footer---3oxVH","copyright":"src-components-Footer----Footer-module---copyright---3rznw","menu":"src-components-Footer----Footer-module---menu---3xrv-","menuItem":"src-components-Footer----Footer-module---menuItem---2nFlI","menuItemActive":"src-components-Footer----Footer-module---menuItemActive---2zgIl","slideInTop":"src-components-Footer----Footer-module---slideInTop---3-6eD","slideInTopMild":"src-components-Footer----Footer-module---slideInTopMild---25wzd","slideInBottom":"src-components-Footer----Footer-module---slideInBottom---2EdEw","slideInBottomMild":"src-components-Footer----Footer-module---slideInBottomMild---2l1LQ","slideOutTop":"src-components-Footer----Footer-module---slideOutTop---e2hxd","slideOutTopMild":"src-components-Footer----Footer-module---slideOutTopMild---3E7sv","slideOutBottom":"src-components-Footer----Footer-module---slideOutBottom---NqhJK","slideOutBottomMild":"src-components-Footer----Footer-module---slideOutBottomMild---2ZFd7","shake-horizontal":"src-components-Footer----Footer-module---shake-horizontal---2vmUn"};

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Footer = __webpack_require__(184);
	
	var _Footer2 = _interopRequireDefault(_Footer);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Footer2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _paths = __webpack_require__(55);
	
	var _paths2 = _interopRequireDefault(_paths);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Icon = function Icon(props) {
	  var styles = _extends({
	    fill: 'currentColor',
	    lineHeight: 'inherit',
	    stroke: 'currentColor',
	    strokeWidth: 0,
	    verticalAlign: props.valign
	  }, props.styles);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      height: props.size,
	      width: props.size,
	      style: styles,
	      viewBox: '0 0 1024 1024'
	    }, props),
	    _react2.default.createElement('path', { d: _paths2.default[props.type] })
	  );
	};
	
	Icon.propTypes = {
	  size: _propTypes2.default.number,
	  styles: _propTypes2.default.object,
	  type: _propTypes2.default.string.isRequired,
	  valign: _propTypes2.default.string
	};
	
	Icon.defaultProps = {
	  size: 16,
	  valign: 'middle'
	};
	
	exports.default = Icon;
	module.exports = exports['default'];

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Icon = __webpack_require__(54);
	
	var _Icon2 = _interopRequireDefault(_Icon);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Icon2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var icons = {
	  bed: 'M1022.3 690c1.6-4.2 2.1-8.9 0.7-13.6l-84.4-274.1V149.3c0-58.8-47.8-106.7-106.7-106.7H192c-58.8 0-106.7 47.9-106.7 106.7v252.9L1 676.4c-1.4 4.7-0.9 9.3 0.7 13.6 -1 4.5-1.7 9.2-1.7 14v170.7V960c0 11.8 9.6 21.3 21.3 21.3h85.3c11.8 0 21.3-9.6 21.3-21.3v-64h768v64c0 11.8 9.6 21.3 21.3 21.3h85.3c11.8 0 21.3-9.6 21.3-21.3v-85.3V704C1024 699.1 1023.4 694.5 1022.3 690zM128 149.3c0-35.3 28.7-64 64-64h640c35.3 0 64 28.7 64 64V384h-58l-19.9-79.5C811 275.9 785.4 256 756 256H618.7c-35.3 0-64 28.7-64 64v64h-85.3v-64c0-35.3-28.7-64-64-64H268c-29.4 0-55 20-62.1 48.5L186 384h-58V149.3zM794.2 418.5c-4.1 5.2-10.2 8.2-16.9 8.2H618.7c-11.7 0-21.3-9.6-21.3-21.3V320c0-11.8 9.6-21.3 21.3-21.3h137.4c9.8 0 18.3 6.6 20.7 16.1l21.3 85.3C799.7 406.6 798.3 413.2 794.2 418.5zM426.7 320v85.1c0 0.1 0 0.1 0 0.2 0 0 0 0.1 0 0.1 0 11.7-9.6 21.2-21.3 21.2H246.7c-6.7 0-12.8-3-16.9-8.2 -4.1-5.2-5.5-11.9-3.9-18.3l21.3-85.3c2.4-9.5 10.9-16.1 20.7-16.1h137.3C417.1 298.7 426.7 308.2 426.7 320zM122.4 426.7h64.2c2.3 6.4 5.2 12.5 9.5 18.1 12.3 15.6 30.7 24.6 50.5 24.6h158.7c27.8 0 51.2-17.9 60.1-42.7h93.2c8.8 24.8 32.3 42.7 60.1 42.7h158.7c19.8 0 38.2-9 50.5-24.6 4.3-5.5 7.3-11.7 9.5-18.1h64.3l65.9 214.1c-2.5-0.3-4.9-0.8-7.5-0.8H64c-2.6 0-5 0.5-7.4 0.8L122.4 426.7zM85.3 938.7H42.7V896h42.7L85.3 938.7 85.3 938.7zM981.3 938.7h-42.7V896h42.7V938.7zM981.3 853.3H42.7V704c0-11.8 9.6-21.3 21.3-21.3h896c11.7 0 21.3 9.6 21.3 21.3V853.3z',
	  bedroom: 'M648.5 650.3V494.9c0-28.2-23-51.2-51.2-51.2H119.5c-28.2 0-51.2 23-51.2 51.2v155.3C29.4 658.2 0 692.7 0 733.9v102.4 170.7c0 9.4 7.6 17.1 17.1 17.1h68.3c9.4 0 17.1-7.6 17.1-17.1v-51.2h512v51.2c0 9.4 7.6 17.1 17.1 17.1h68.3c9.4 0 17.1-7.6 17.1-17.1V836.3 733.9C716.8 692.7 687.4 658.2 648.5 650.3zM102.4 494.9c0-9.4 7.7-17.1 17.1-17.1h477.9c9.4 0 17.1 7.7 17.1 17.1v153.6h-34.1v-68.3c0-28.2-23-51.2-51.2-51.2H426.7c-28.2 0-51.2 23-51.2 51.2v68.3h-34.1v-68.3c0-28.2-23-51.2-51.2-51.2H187.7c-28.2 0-51.2 23-51.2 51.2v68.3h-34.1V494.9zM546.1 580.3v68.3H409.6v-68.3c0-9.4 7.7-17.1 17.1-17.1h102.4C538.5 563.2 546.1 570.9 546.1 580.3zM307.2 580.3v68.3H170.7v-68.3c0-9.4 7.7-17.1 17.1-17.1h102.4C299.5 563.2 307.2 570.9 307.2 580.3zM682.7 989.9h-34.1v-51.2c0-9.4-7.6-17.1-17.1-17.1H85.3c-9.4 0-17.1 7.6-17.1 17.1v51.2H34.1V853.3h648.5V989.9zM682.7 819.2H34.1v-85.3c0-28.2 23-51.2 51.2-51.2h68.3 170.7 68.3 170.7 68.3c28.2 0 51.2 23 51.2 51.2V819.2zM1006.9 648.5H768c-9.4 0-17.1 7.6-17.1 17.1v136.5 119.5h34.1V819.2h204.8v102.4h34.1V802.1 665.6C1024 656.2 1016.4 648.5 1006.9 648.5zM989.9 785.1H785.1V682.7h204.8V785.1zM853.3 716.8h68.3v34.1h-68.3V716.8zM971.9 506.6l-34.1-102.4c-2.3-7-8.8-11.7-16.2-11.7h-68.3c-7.4 0-13.9 4.7-16.2 11.7L803 506.6c-1.7 5.2-0.9 10.9 2.4 15.4 3.2 4.5 8.4 7.1 13.8 7.1h51.2v51.2h-34.1v34.1h102.4v-34.1h-34.1v-51.2h51.2c5.5 0 10.6-2.6 13.8-7.1C972.8 517.5 973.7 511.8 971.9 506.6zM842.9 494.9l22.8-68.3h43.7l22.7 68.3H842.9zM1013.9 223.4L519 1.5c-4.5-2-9.5-2-14 0L10.1 223.4C3.9 226.1 0 232.2 0 238.9v204.8h34.1V250L512 35.8 989.9 250v193.7h34.1V238.9C1024 232.2 1020.1 226.1 1013.9 223.4zM629.8 236.1l-33.7 5.7c0.8 4.7 1.2 9.4 1.2 14.2 0 47.1-38.3 85.3-85.3 85.3s-85.3-38.3-85.3-85.3 38.3-85.3 85.3-85.3c9.8 0 19.4 1.6 28.5 4.9l11.4-32.2c-12.8-4.5-26.2-6.8-39.8-6.8 -65.9 0-119.5 53.6-119.5 119.5S446.1 375.5 512 375.5 631.5 321.9 631.5 256C631.5 249.3 630.9 242.6 629.8 236.1zM619.4 141.5L512 248.9l-22.1-22.1L465.8 251l34.1 34.1c3.3 3.3 7.7 5 12.1 5 4.4 0 8.7-1.7 12.1-5l119.5-119.5L619.4 141.5z',
	  bike: 'M810.7 416c-19.5 0-38.3 2.6-56.3 7.5l-54.9-142.9 19.9-20.4c8.1-8.4 8-21.7-0.2-30l-42.7-42.6c-4-4-9.4-6.3-15.1-6.3H554.7c-11.8 0-21.3 9.6-21.3 21.3 0 11.8 9.6 21.3 21.3 21.3h97.8l21.6 21.5 -14.8 15.1c-5.9 6.1-7.4 14.9-4.7 22.4 0 0 0 0.1 0 0.2l19.6 51L384 370.5v-39.8h64c11.8 0 21.3-9.6 21.3-21.3S459.8 288 448 288H320c-11.8 0-21.3 9.5-21.3 21.3s9.5 21.3 21.3 21.3h21.3v58.2L311.5 440c-29.4-15.3-62.8-24-98.2-24C95.7 416 0 511.7 0 629.3 0 747 95.7 842.7 213.3 842.7c103 0 189.2-73.4 209-170.7h29.3c8.8 24.8 32.5 42.7 60.3 42.7 35.3 0 64-28.7 64-64 0-14.8-5-28.4-13.4-39.2l136.7-212.6 15.3 40c-69.5 35.2-117.2 107.3-117.2 190.4 0 117.7 95.7 213.4 213.3 213.4S1024 747 1024 629.3C1024 511.7 928.3 416 810.7 416zM213.3 800c-94.1 0-170.7-76.6-170.7-170.7 0-94.1 76.6-170.6 170.7-170.6 27.6 0 53.6 6.6 76.7 18.2l-95.1 163c-5.9 10.2-2.5 23.2 7.7 29.2 3.4 1.9 7.1 2.9 10.7 2.9 0 0 0.1 0 0.1 0h165.2C359.6 745.6 292.7 800 213.3 800zM250.5 629.3l75-128.5c35.8 31.3 58.5 77.3 58.5 128.5H250.5zM451.7 629.3h-25c0-66.9-31-126.8-79.4-165.9l15.4-26.4 100.5 172.3C458.2 615.2 454.3 621.9 451.7 629.3zM512 672c-11.8 0-21.3-9.6-21.3-21.3 0-11.8 9.6-21.4 21.3-21.4 11.8 0 21.3 9.6 21.3 21.4C533.3 662.4 523.8 672 512 672zM526.7 588.4c-4.7-1.1-9.6-1.7-14.7-1.7 -4.1 0-8.1 0.4-12 1.1l-102.7-176 264-33L526.7 588.4zM810.7 800C716.6 800 640 723.4 640 629.3c0-64.9 36.5-121.5 90-150.3l60.8 158c3.3 8.4 11.3 13.7 19.9 13.7 2.5 0 5.1-0.5 7.7-1.4 11-4.3 16.5-16.6 12.3-27.6l-60.8-158.1c13.1-3.2 26.8-5 40.9-5 94.1 0 170.7 76.6 170.7 170.6C981.3 723.4 904.8 800 810.7 800z',
	  boot: 'M1019 696.2l-68.3-68.3c-2.6-2.6-6-4.3-9.6-4.8l-116-16.6 -284-172.9 -98.2-310.8c-1.4-4.4-4.4-8-8.5-10.1 -4-2.1-8.8-2.4-13.2-1l-55.7 18.6c-34.9 11.6-58.4 44.2-58.4 80.9v2h-85.3c-2.3 0-4.5 0.4-6.6 1.3l-112.9 47v-14.2c0-28.2-23-51.2-51.2-51.2S0 219.2 0 247.5v68.3h0.2c0 1.4-0.1 2.7 0.3 4.1 32.8 131.3 32.8 270 0 401.3 -0.3 1.3-0.5 2.7-0.5 4.1v102.4c0 47.1 38.3 85.3 85.3 85.3h221.9c5.5 0 10.7-2.7 13.9-7.2l36-50.5 92 21.2 13.5 26.9c2.9 5.8 8.8 9.4 15.3 9.4h190.9c124.1 0 244.4-36.4 347.7-105.3 4.7-3.2 7.6-8.5 7.6-14.2v-85.3C1024 703.7 1022.2 699.4 1019 696.2zM436.8 216.6l60 190.1 -58-35.3 -29.2-43.8v-102L436.8 216.6zM341.3 211.3c0-22.1 14.1-41.6 35-48.6l39.3-13.1 10.9 34.4 -39.3 13.1c-7 2.3-11.7 8.8-11.7 16.2v63.1l-34.1-51.2V211.3zM307.2 349.9V247.5h7.9l97.3 146c1.4 2.1 3.2 3.8 5.3 5.1l34.5 21 -54.8 54.8 24.1 24.1 60.6-60.6 30.1 18.3 0.4 1.2 1.1-0.3 23.3 14.2 -54.3 54.3 24.1 24.1 60.2-60.2 54.9 33.4 -53.8 53.8 24.1 24.1 59.7-59.7 54.9 33.4 -53.4 53.4 24.1 24.1 59.3-59.3 54.9 33.4 -52.9 52.9 24.1 24.1 62.2-62.2 105.4 15.1 44.7 44.7L750 775.9l-302.6-67.2c-2.1-0.5-4.4-0.5-6.5-0.2l-83.5 13.9c-6.7-109.8-68.1-204.8-157.5-258.2l102.3-102.3C305.4 358.7 307.2 354.4 307.2 349.9zM56.3 453.4c142.3 10.8 256 124.6 266.9 266.9l-114.2-28.6c-3.4-0.9-7.2-0.6-10.5 0.7l-79.5 31.8 -78.5-26.2C57.4 617.7 62.6 535.2 56.3 453.4zM225.3 247.5h47.8v95.3L168.3 447.5c-35.5-16.2-74.3-26.1-115.2-28.5 -3.7-31.3-8.9-62.4-16.1-93.2L225.3 247.5zM34.1 247.5c0-9.4 7.6-17.1 17.1-17.1s17.1 7.7 17.1 17.1v28.5l-34.1 14.2V247.5zM989.9 784.4c-11.2 7.2-22.6 13.9-34.1 20.3v-11.1h-34.1v28.5c-11.2 5.3-22.6 10.2-34.1 14.7v-9.1h-34.1v21.4c-11.3 3.7-22.6 7.1-34.1 10.1v-14.4h-34.1v22.4c-11.3 2.3-22.7 4.4-34.1 6v-11.3h-34.1v15c-11.3 0.9-22.7 1.3-34.1 1.6v-16.6h-34.1v17.1h-34.1v-17.1h-34.1v17.1h-34.1v-17.1H512v17.1h-23.6l-12.4-24.7c-2.3-4.6-6.5-7.9-11.4-9l-110.9-25.6c-6.7-1.5-13.7 1.1-17.7 6.7l-37.6 52.6h-8.3v-34.1H256v34.1h-34.1v-34.1h-34.1v34.1h-34.1v-34.1h-34.1v34.1H85.3v-34.1H51.2v20.8c-10.4-9.4-17.1-22.8-17.1-37.9v-95.8l79.9 26.6c3.8 1.3 8 1.1 11.7-0.3l80.2-32.1L337.2 759c2.2 0.6 4.6 0.7 6.9 0.3l99.1-16.5 304 67.5c1.2 0.3 2.4 0.4 3.7 0.4 1.8 0 3.7-0.3 5.4-0.9l233.5-77.8V784.4z',
	  briefcase: 'M1004.6 187.6c-12.9-13.2-28.9-20-47.7-20H703.2V83.8c0-17.2-13.3-31.1-30.5-31.1h-3.3H666 358h-3.3 -3.3c-17.2 0-31.1 13.9-31.1 31.1v83.8H67.2c-18.9 0-34.8 6.8-47.7 20C6.8 200.5 0 216.5 0 234.8v669.3c0 18.3 6.5 34.5 19.4 47.7 12.6 12.9 28.9 19.4 47.7 19.4h889.7c18.9 0 35.1-6.5 47.7-19.4 12.9-13.2 19.4-29.4 19.4-47.7V234.8C1024 216.5 1017.2 200.5 1004.6 187.6zM381.8 114.3h260.3v53.3H381.8V114.3zM218.1 909.7h-151c-2.8 0-6.1-3.3-6.1-5.6V234.8c0-3.9 2.2-5.6 6.1-5.6h151V909.7zM744.3 909.7H280.8V229.2h463.4V909.7zM962.4 904.1c0 3.9-1.7 5.6-5.6 5.6h-151V229.2h151c3.9 0 5.6 1.7 5.6 5.6V904.1z',
	  calendar: 'M938.7 136.5h-17.1V51.2c0-28.2-23-51.2-51.2-51.2h-34.1c-28.2 0-51.2 23-51.2 51.2v85.3H238.9V51.2C238.9 23 216 0 187.7 0h-34.1c-28.2 0-51.2 23-51.2 51.2v85.3H85.3C38.3 136.5 0 174.8 0 221.9v716.8c0 47.1 38.3 85.3 85.3 85.3h853.3c47.1 0 85.3-38.3 85.3-85.3V221.9C1024 174.8 985.7 136.5 938.7 136.5zM819.2 153.6V51.2c0-9.4 7.6-17.1 17.1-17.1h34.1c9.4 0 17.1 7.6 17.1 17.1v102.4 68.3c0 9.4-7.6 17.1-17.1 17.1h-34.1c-9.4 0-17.1-7.6-17.1-17.1V153.6zM136.5 153.6V51.2c0-9.4 7.6-17.1 17.1-17.1h34.1c9.4 0 17.1 7.6 17.1 17.1v102.4 68.3c0 9.4-7.6 17.1-17.1 17.1h-34.1c-9.4 0-17.1-7.6-17.1-17.1V153.6zM989.9 938.7c0 28.2-23 51.2-51.2 51.2H85.3c-28.2 0-51.2-23-51.2-51.2V443.7h955.7V938.7zM989.9 409.6H34.1V221.9c0-28.2 23-51.2 51.2-51.2h17.1v51.2c0 28.2 23 51.2 51.2 51.2h34.1c28.2 0 51.2-23 51.2-51.2v-51.2h546.1v51.2c0 28.2 23 51.2 51.2 51.2h34.1c28.2 0 51.2-23 51.2-51.2v-51.2h17.1c28.2 0 51.2 23 51.2 51.2V409.6zM699.7 221.9H324.3c-9.4 0-17.1 7.6-17.1 17.1v102.4c0 9.4 7.6 17.1 17.1 17.1h375.5c9.4 0 17.1-7.6 17.1-17.1V238.9C716.8 229.5 709.2 221.9 699.7 221.9zM682.7 324.3H341.3V256h341.3V324.3zM221.9 494.9H119.5c-9.4 0-17.1 7.6-17.1 17.1v85.3c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1V512C238.9 502.6 231.3 494.9 221.9 494.9zM204.8 580.3h-68.3v-51.2h68.3V580.3zM443.7 494.9H341.3c-9.4 0-17.1 7.6-17.1 17.1v85.3c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1V512C460.8 502.6 453.2 494.9 443.7 494.9zM426.7 580.3h-68.3v-51.2h68.3V580.3zM682.7 494.9H580.3c-9.4 0-17.1 7.6-17.1 17.1v85.3c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1V512C699.7 502.6 692.1 494.9 682.7 494.9zM665.6 580.3h-68.3v-51.2h68.3V580.3zM904.5 494.9H802.1c-9.4 0-17.1 7.6-17.1 17.1v85.3c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1V512C921.6 502.6 914 494.9 904.5 494.9zM887.5 580.3h-68.3v-51.2h68.3V580.3zM221.9 665.6H119.5c-9.4 0-17.1 7.6-17.1 17.1V768c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1v-85.3C238.9 673.2 231.3 665.6 221.9 665.6zM204.8 750.9h-68.3v-51.2h68.3V750.9zM443.7 665.6H341.3c-9.4 0-17.1 7.6-17.1 17.1V768c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1v-85.3C460.8 673.2 453.2 665.6 443.7 665.6zM426.7 750.9h-68.3v-51.2h68.3V750.9zM682.7 665.6H580.3c-9.4 0-17.1 7.6-17.1 17.1V768c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1v-85.3C699.7 673.2 692.1 665.6 682.7 665.6zM665.6 750.9h-68.3v-51.2h68.3V750.9zM904.5 665.6H802.1c-9.4 0-17.1 7.6-17.1 17.1V768c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1v-85.3C921.6 673.2 914 665.6 904.5 665.6zM887.5 750.9h-68.3v-51.2h68.3V750.9zM221.9 836.3H119.5c-9.4 0-17.1 7.6-17.1 17.1v85.3c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1v-85.3C238.9 843.9 231.3 836.3 221.9 836.3zM204.8 921.6h-68.3v-51.2h68.3V921.6zM443.7 836.3H341.3c-9.4 0-17.1 7.6-17.1 17.1v85.3c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1v-85.3C460.8 843.9 453.2 836.3 443.7 836.3zM426.7 921.6h-68.3v-51.2h68.3V921.6zM686.6 825.3l-73.4 88 -38-38 -24.1 24.1 51.2 51.2c3.2 3.2 7.5 5 12.1 5 0.3 0 0.5 0 0.8 0 4.8-0.2 9.3-2.4 12.4-6.1l85.3-102.4L686.6 825.3zM891.4 825.3l-73.4 88 -38-38 -24.1 24.1 51.2 51.2c3.2 3.2 7.5 5 12.1 5 0.3 0 0.5 0 0.8 0 4.8-0.2 9.3-2.4 12.4-6.1l85.3-102.4L891.4 825.3z',
	  caret: 'M315.7 0L196.3 119.5 588.8 512 196.3 904.5 315.7 1024l512-512L315.7 0z',
	  climbing: 'M829.9 132.7c114.2 20.8 179.1 68.3 179.9 68.9 1.6 1.2 3.5 1.8 5.3 1.8 2.2 0 4.4-0.8 6.1-2.4 3.2-3 3.7-7.8 1.4-11.4C963.1 98.4 850.9 52.4 767.2 29.9c-90-24.2-164.9-27.2-168-27.3 -0.1 0-0.2 0-0.3 0H8.9C4.3 2.5 0.5 6 0 10.6s2.7 8.7 7.2 9.6c187.3 36 216.7 109.6 216.9 110.2 1.2 3.6 4.6 6 8.4 6h116.7v395.2c-15.6 5.1-27.1 21.4-27.1 40.6 0 10.7-2.3 15.5-5.2 21.6 -3.3 6.8-7 14.6-7 29.3 0 14.8 3.7 22.5 7 29.3 2.9 6.1 5.2 10.9 5.2 21.6 0 10.7-2.3 15.5-5.2 21.6 -3.3 6.8-7 14.6-7 29.3 0 14.8 3.7 22.5 7 29.3 2.9 6.1 5.2 10.9 5.2 21.6 0 10.7-2.3 15.5-5.2 21.6 -3.3 6.8-7 14.6-7 29.3 0 14.8 3.7 22.5 7 29.3 2.9 6.1 5.2 10.9 5.2 21.6 0 10.7-2.3 15.5-5.2 21.6 -3.3 6.8-7 14.6-7 29.3 0 14.8 3.7 22.5 7 29.3 2.9 6.1 5.2 10.9 5.2 21.6 0 0.1 0 0.3 0 0.4 0.4 22.9 17.1 41.4 37.4 41.4h70.5c20.7 0 37.5-19 37.5-42.3v-407c0-19.7-11.9-36.2-28.1-40.9V136.4H588c0.6 0 1.1-0.1 1.7-0.2 44.6-8.7 89-13.2 132.2-13.2C758.3 123.1 799.8 127.6 829.9 132.7zM449.7 572.2v407c0 13.5-8.8 24.5-19.6 24.5h-70.5c-10.8 0-19.6-11-19.6-24.5 0-0.1 0-0.2 0-0.2 -0.1-14.3-3.8-21.9-7-28.6 -2.9-6.1-5.2-10.9-5.2-21.6 0-10.7 2.3-15.5 5.2-21.6 3.3-6.8 7-14.6 7-29.3 0-14.8-3.7-22.5-7-29.3 -2.9-6.1-5.2-10.9-5.2-21.6s2.3-15.5 5.2-21.6c3.3-6.8 7-14.6 7-29.3 0-14.8-3.7-22.5-7-29.3 -2.9-6.1-5.2-10.9-5.2-21.6 0-10.7 2.3-15.5 5.2-21.6 3.3-6.8 7-14.6 7-29.3 0-14.8-3.7-22.5-7-29.3 -2.9-6.1-5.2-10.9-5.2-21.6 0-10.7 2.3-15.5 5.2-21.6 3.3-6.8 7-14.6 7-29.3 0-13.5 8.8-24.5 19.6-24.5h44v318.6c0 4.9 4 8.9 8.9 8.9s8.9-4 8.9-8.9V547.7h8.7C440.9 547.7 449.7 558.7 449.7 572.2zM421.7 529.9h-54.6V136.4h54.6V529.9zM894.5 129.5v-20.8c0-4.9-4-8.9-8.9-8.9s-8.9 4-8.9 8.9v15.8c-12.8-3.3-26.3-6.4-40.6-9V90.9c0-4.9-4-8.9-8.9-8.9s-8.9 4-8.9 8.9v21.6c-13-2-26.5-3.7-40.6-4.9V83.9c0-4.9-4-8.9-8.9-8.9s-8.9 4-8.9 8.9v22.4c-12.3-0.7-24.9-1.1-37.9-1.1 -0.9 0-1.8 0-2.7 0V73.2c0-4.9-4-8.9-8.9-8.9s-8.9 4-8.9 8.9v32.4c-13.5 0.4-27 1.3-40.6 2.5V59.2c0-4.9-4-8.9-8.9-8.9s-8.9 4-8.9 8.9v49.5c0 0.4 0.1 0.8 0.1 1.2 -18.5 2.2-37.2 5-55.8 8.6h-349c-9-16.7-43.5-64.1-155.3-98.2h515.9c3.8 0.2 77.7 3.5 163.9 26.7 68.2 18.4 156 52.7 215.5 115.2C957.4 151.8 929.4 139.8 894.5 129.5zM396.2 29.9c-20.9 0-37.9 17-37.9 37.9 0 20.9 17 37.9 37.9 37.9s37.9-17 37.9-37.9C434 46.9 417.1 29.9 396.2 29.9zM396.2 87.8c-11.1 0-20-9-20-20 0-11 9-20 20-20s20 9 20 20C416.2 78.8 407.2 87.8 396.2 87.8zM849.4 306.5H609c-24.9 0-45.2 20.3-45.2 45.2v297.2c0 0.5 0 0.9 0.1 1.4l0 0.1 0 0.6c0 0.7 0 1.4 0 2 0 72 58.6 130.6 130.6 130.6 65.9 0 124.4-49.2 133.3-112l66.6-318c0.1-0.6 0.2-1.2 0.2-1.8C894.5 326.8 874.3 306.5 849.4 306.5zM643.2 627.1l0-234.7c0-11.3 5.9-19.7 11.2-19.7h133.2c5.2 0 11 8.1 11.2 19.1L763 642.3c0 0.1 0 0.3 0 0.4 -4 40.1-30.3 70.4-61.3 70.4 -32.8 0-58.5-36.4-58.5-83 0-0.4 0-0.8 0-1.2l0-0.8c0-0.1 0-0.2 0-0.4L643.2 627.1zM810.4 436h48.5l-38.3 182.7h-36.2L810.4 436zM862.6 418.2h-49.6l3.5-24.5c0.1-0.4 0.1-0.8 0.1-1.3 0-21-12.7-37.5-29-37.5H654.4c-16.3 0-29 16.5-29 37.5v234.5c0 0.4 0 0.7 0 1l0 0.1 0 0.4c0 0.5 0 1.1 0 1.6 0 27.3 7.6 52.6 21.5 71.1 14.3 19.1 33.7 29.6 54.8 29.6 40.2 0 74.1-37.1 79-86.3l1.1-8.1h35l-6.6 31.5c0 0.2-0.1 0.4-0.1 0.6 -7.6 54.4-58.5 96.9-115.7 96.9 -62.2 0-112.7-50.6-112.7-112.7 0-0.5 0-1 0-1.4l0-1.1c0-0.2 0-0.3 0-0.5 0-0.3 0-0.6 0-0.8l0-0.2V351.7c0-15.1 12.3-27.3 27.3-27.3h240.4c14.8 0 26.9 11.8 27.3 26.5L862.6 418.2zM844.2 449.5c0.9-4.8-2.4-9.5-7.2-10.3 -4.9-0.8-9.5 2.4-10.3 7.2L798.8 602c-0.9 4.8 2.4 9.5 7.2 10.3 0.5 0.1 1.1 0.1 1.6 0.1 4.2 0 8-3 8.8-7.3L844.2 449.5z',
	  close: 'M1024 89L935 0 512 423 89 0 0 89l423 423L0 935l89 89 423-423 423 423 89-89L601 512 1024 89z',
	  facebook: 'M938.7 0H85.3C37.5 0 0 37.5 0 85.3v853.3c0 47.8 37.5 85.3 85.3 85.3h392.5 204.8 256c47.8 0 85.3-37.5 85.3-85.3V85.3C1024 37.5 986.5 0 938.7 0zM512 989.9V648.5H375.5V512H512V392.5c0-97.3 75.1-179.2 170.7-187.7h153.6v136.5H699.7c-29 0-51.2 22.2-51.2 51.2V512h170.7v136.5H648.5v341.3L512 989.9 512 989.9zM989.9 938.7c0 29-22.2 51.2-51.2 51.2h-256V682.7h170.7V477.9H682.7v-85.3c0-10.2 6.8-17.1 17.1-17.1h170.7V170.7H681c-114.3 10.2-203.1 107.5-203.1 221.9v85.3H341.3v204.8h136.5v307.2H85.3c-29 0-51.2-22.2-51.2-51.2V85.3c0-29 22.2-51.2 51.2-51.2h853.3c29 0 51.2 22.2 51.2 51.2L989.9 938.7 989.9 938.7z',
	  golf: 'M826.3 244.6C789.9 100.7 660.4 0 512 0 363.9 0 234.6 100.3 197.9 243.8s28.6 293.6 158.5 364.7c0 0.6-0.2 1.1-0.2 1.7 0 31.6 30.1 80.2 78.5 103.6 10.4 6.7 29.5 69.5 26.9 259.1 -0.3 18.2 9.2 35.1 24.9 44.3 15.7 9.2 35.1 9.1 50.8-0.1 15.7-9.2 25.2-26.2 24.8-44.4 -3.4-189.5 15.2-252.2 25.5-258.9 48.7-23.4 78.8-72 78.8-103.6 0-0.3-0.1-0.6-0.1-0.9C796.8 538.7 862.7 388.4 826.3 244.6zM572.9 683c-13.6 6.5-49.6 23.6-44.9 290.4 0.1 4.2-1.5 8.3-4.4 11.4 -6.5 6.3-16.8 6.3-23.2 0 -3-3-4.7-7.2-4.6-11.5 3.6-266.6-32.6-283.9-46.2-290.3C425 671.2 405.3 651 394.2 626c75.1 29.8 158.7 30 233.9 0.6C616.9 651.3 597.4 671.3 572.9 683zM512 614.3c-160.2 0-290.1-129.9-290.1-290.1S351.8 34.1 512 34.1 802.1 164 802.1 324.2C801.9 484.4 672.1 614.1 512 614.3zM313.7 428c-6.4-2.7-13.7-1.3-18.6 3.6 -6.6 6.7-6.6 17.5 0 24.2 0.8 0.8 1.7 1.5 2.7 2 0.9 0.7 1.9 1.2 2.9 1.5 1 0.5 2 0.8 3.1 1 1.1 0.2 2.3 0.3 3.4 0.3 2.2 0.1 4.5-0.4 6.5-1.4 2.1-0.9 4-2.1 5.6-3.6 6.6-6.7 6.6-17.5 0-24.2C317.7 430.1 315.8 428.8 313.7 428zM387.6 465.7c-0.9-0.7-1.7-1.4-2.6-2 -1-0.6-2-1.2-3.1-1.5 -1-0.5-2-0.8-3.1-1 -5.6-1.1-11.4 0.6-15.5 4.6 -3.1 3.3-4.9 7.6-4.9 12.1 0 1.1 0.1 2.3 0.3 3.4 0.2 1.1 0.5 2.1 1 3.1 0.4 1.1 0.9 2.1 1.5 3.1 0.7 0.8 1.4 1.7 2 2.6 3.3 3.1 7.6 4.9 12.1 4.9 1.1 0 2.3-0.1 3.4-0.3 1.1-0.2 2.1-0.5 3.1-1 1.1-0.4 2.1-0.9 3.1-1.5 1.9-1.2 3.4-2.7 4.6-4.6 0.6-1 1.2-2 1.5-3.1 0.5-1 0.8-2 1-3.1 0.2-1.1 0.3-2.3 0.3-3.4C392.5 473.3 390.7 469 387.6 465.7zM455.9 482.8c-1.6-1.5-3.5-2.8-5.6-3.6 -4.2-1.7-8.8-1.7-13 0 -2.1 0.9-4 2.1-5.6 3.6 -6.6 6.7-6.6 17.5 0 24.2 1.7 1.5 3.6 2.7 5.6 3.6 4.1 1.8 8.8 1.8 13 0 2.1-0.9 4-2.1 5.6-3.6C462.5 500.3 462.5 489.5 455.9 482.8L455.9 482.8zM419.2 531.9c-1-0.6-2-1.2-3.1-1.5 -1-0.5-2-0.8-3.1-1 -5.6-1.1-11.4 0.6-15.5 4.6 -3.1 3.3-4.9 7.6-4.9 12.1 0 1.1 0.1 2.3 0.3 3.4 0.2 1.1 0.5 2.1 1 3.1 0.4 1.1 0.9 2.1 1.5 3.1 0.7 0.8 1.4 1.7 2 2.6 3.3 3.1 7.6 4.9 12.1 4.9 1.1 0 2.3-0.1 3.4-0.3 1.1-0.2 2.1-0.5 3.1-1 1.1-0.4 2.1-0.9 3.1-1.5 0.8-0.7 1.7-1.4 2.6-2 0.7-0.9 1.4-1.7 2-2.6 0.6-1 1.2-2 1.5-3.1 0.5-1 0.8-2 1-3.1 0.2-1.1 0.3-2.3 0.3-3.4 -0.1-4.5-1.8-8.8-4.9-12.1C420.9 533.2 420.1 532.5 419.2 531.9zM490 551c-0.9-0.7-1.7-1.4-2.6-2 -1-0.6-2-1.2-3.1-1.5 -1-0.5-2-0.8-3.1-1 -5.6-1.1-11.4 0.6-15.5 4.6 -1.5 1.7-2.7 3.6-3.6 5.6 -0.9 2.1-1.3 4.3-1.4 6.5 0.1 4.5 1.8 8.8 4.9 12.1 0.8 0.7 1.7 1.4 2.6 2 0.9 0.6 2 1.2 3.1 1.5 1 0.5 2 0.8 3.1 1 1.1 0.2 2.3 0.3 3.4 0.3 1.1 0 2.3-0.1 3.4-0.3 1.1-0.2 2.1-0.5 3.1-1 1.1-0.4 2.1-0.9 3.1-1.5 0.9-0.6 1.7-1.3 2.6-2 3.1-3.3 4.9-7.6 4.9-12.1 0-2.2-0.5-4.4-1.4-6.5C492.7 554.6 491.5 552.7 490 551zM558.2 551c-1.7-1.5-3.6-2.7-5.6-3.6 -6.4-2.7-13.7-1.3-18.6 3.6 -1.5 1.7-2.7 3.6-3.6 5.6 -0.9 2.1-1.3 4.3-1.4 6.5 0 9.4 7.6 17.1 17.1 17.1s17.1-7.6 17.1-17.1c0-2.2-0.5-4.4-1.4-6.5C561 554.6 559.7 552.7 558.2 551zM623.9 531.9c-1-0.6-2-1.2-3.1-1.5 -1-0.5-2-0.8-3.1-1 -5.6-1.1-11.4 0.6-15.5 4.6 -3.1 3.3-4.9 7.6-4.9 12.1 0 1.1 0.1 2.3 0.3 3.4 0.2 1.1 0.5 2.1 1 3.1 0.4 1.1 0.9 2.1 1.5 3.1 0.7 0.8 1.4 1.7 2 2.6 3.3 3.1 7.6 4.9 12.1 4.9 1.1 0 2.3-0.1 3.4-0.3 1.1-0.2 2.1-0.5 3.1-1 1.1-0.4 2.1-0.9 3.1-1.5 0.8-0.7 1.7-1.4 2.6-2 0.7-0.9 1.4-1.7 2-2.6 0.6-1 1.2-2 1.5-3.1 0.5-1 0.8-2 1-3.1 0.2-1.1 0.3-2.3 0.3-3.4 -0.1-4.5-1.8-8.8-4.9-12.1C625.7 533.2 624.8 532.5 623.9 531.9zM524.1 482.8L524.1 482.8c-4.3-4.3-10.6-6-16.5-4.4 -5.9 1.6-10.5 6.2-12.1 12.1 -1.6 5.9 0.1 12.2 4.4 16.5 0.8 0.7 1.7 1.4 2.6 2 0.9 0.6 2 1.2 3.1 1.5 1 0.5 2 0.8 3.1 1 1.1 0.2 2.3 0.3 3.4 0.3 1.1 0 2.3-0.1 3.4-0.3 1.1-0.2 2.1-0.5 3.1-1 1.1-0.4 2.1-0.9 3.1-1.5 0.9-0.6 1.7-1.3 2.6-2C530.7 500.3 530.7 489.5 524.1 482.8zM592.4 482.8L592.4 482.8c-0.9-0.7-1.7-1.4-2.6-2.1 -1-0.6-2-1.2-3.1-1.5 -1-0.5-2-0.8-3.1-1 -5.6-1.1-11.4 0.7-15.5 4.6 -0.7 0.8-1.4 1.7-2 2.7 -0.7 0.9-1.2 1.9-1.5 2.9 -0.5 1-0.8 2-1 3.1 -0.2 1.1-0.3 2.3-0.3 3.4 0 4.5 1.7 8.9 4.9 12.1s7.6 5 12.1 4.9c1.1 0 2.3-0.1 3.4-0.3 1.1-0.2 2.1-0.5 3.1-1 1.1-0.4 2.1-0.9 3.1-1.5 0.9-0.6 1.7-1.3 2.6-2C599 500.3 599 489.5 592.4 482.8zM658.1 463.6c-1-0.6-2-1.2-3.1-1.5 -1-0.5-2-0.8-3.1-1 -5.6-1.1-11.4 0.6-15.5 4.6 -3.1 3.3-4.9 7.6-4.9 12.1 0 1.1 0.1 2.3 0.3 3.4 0.2 1.1 0.5 2.1 1 3.1 0.4 1.1 0.9 2.1 1.5 3.1 0.7 0.8 1.4 1.7 2 2.6 3.3 3.1 7.6 4.9 12.1 4.9 1.1 0 2.3-0.1 3.4-0.3 1.1-0.2 2.1-0.5 3.1-1 1.1-0.4 2.1-0.9 3.1-1.5 1.9-1.2 3.4-2.7 4.6-4.6 0.6-1 1.2-2 1.5-3.1 0.5-1 0.8-2 1-3.1 0.2-1.1 0.3-2.3 0.3-3.4 -0.1-4.5-1.8-8.8-4.9-12.1C659.8 465 658.9 464.3 658.1 463.6zM723.3 428c-4.1-1.9-8.9-1.9-13 0 -2.1 0.9-4 2.1-5.6 3.6 -3.1 3.3-4.9 7.6-4.9 12.1 0 1.1 0.1 2.3 0.3 3.4 0.2 1.1 0.5 2.1 1 3.1 0.4 1.1 0.9 2.1 1.5 3.1 0.7 0.8 1.4 1.7 2 2.6 1.7 1.5 3.6 2.7 5.6 3.6 4.1 1.8 8.8 1.8 13 0 2.1-0.9 4-2.1 5.6-3.6 0.7-0.9 1.4-1.7 2-2.6 0.6-1 1.2-2 1.5-3.1 0.5-1 0.8-2 1-3.1 0.2-1.1 0.3-2.3 0.3-3.4 -0.1-4.5-1.8-8.8-4.9-12.1C727.2 430.1 725.3 428.8 723.3 428zM285.2 346.2c-5-4.7-12.2-6.1-18.6-3.6 -2.1 0.9-4 2.1-5.6 3.6 -3.1 3.3-4.9 7.6-4.9 12.1 0 2.2 0.5 4.4 1.4 6.5 1.6 4.3 4.9 7.7 9.2 9.2 2.1 0.9 4.3 1.3 6.5 1.4 4.5-0.1 8.8-1.8 12.1-4.9 1.5-1.7 2.7-3.6 3.6-5.6 0.9-2.1 1.3-4.3 1.4-6.5C290.1 353.8 288.3 349.5 285.2 346.2zM357.1 386c-1.6-4.3-4.9-7.7-9.2-9.2 -4.2-1.7-8.8-1.7-13 0 -4.3 1.6-7.6 4.9-9.2 9.2 -0.9 2.1-1.3 4.3-1.4 6.5 0.1 4.5 1.8 8.8 4.9 12.1 1.7 1.5 3.6 2.7 5.6 3.6 4.1 1.8 8.8 1.8 13 0 2.1-0.9 4-2.1 5.6-3.6 3.1-3.3 4.9-7.6 4.9-12.1C358.4 390.2 357.9 388 357.1 386zM763 346.2c-1.7-1.5-3.6-2.7-5.6-3.6 -3.1-1.4-6.6-1.7-9.9-1 -1.1 0.2-2.1 0.5-3.1 1 -1.1 0.4-2.1 0.9-3.1 1.5 -0.9 0.6-1.8 1.3-2.6 2 -3.1 3.3-4.9 7.6-4.9 12.1 0 2.2 0.5 4.4 1.4 6.5 0.9 2.1 2.1 4 3.6 5.6 3.3 3.1 7.6 4.9 12.1 4.9 2.2 0 4.4-0.5 6.5-1.4 4.3-1.6 7.7-4.9 9.2-9.2 0.9-2.1 1.3-4.3 1.4-6.5C767.9 353.8 766.1 349.5 763 346.2zM698.3 386c-1.6-4.3-4.9-7.7-9.2-9.2 -4.2-1.7-8.8-1.7-13 0 -4.3 1.6-7.6 4.9-9.2 9.2 -0.9 2.1-1.3 4.3-1.4 6.5 0.1 4.5 1.8 8.8 4.9 12.1 1.7 1.5 3.6 2.7 5.6 3.6 4.1 1.8 8.8 1.8 13 0 2.1-0.9 4-2.1 5.6-3.6 3.1-3.3 4.9-7.6 4.9-12.1C699.7 390.2 699.2 388 698.3 386zM397.5 421.7c1.7 1.5 3.6 2.7 5.6 3.6 4.1 1.8 8.8 1.8 13 0 4.3-1.6 7.7-4.9 9.2-9.2 1.8-4.1 1.8-8.8 0-13 -1.6-4.3-4.9-7.7-9.2-9.2 -4.2-1.7-8.8-1.7-13 0 -4.3 1.6-7.6 4.9-9.2 9.2 -1.8 4.1-1.8 8.8 0 13C394.8 418.1 396 420 397.5 421.7zM477.9 443.7c4.5 0 8.9-1.7 12.1-4.9 3.2-3.2 5-7.6 4.9-12.1 0-1.1-0.1-2.3-0.3-3.4 -0.2-1.1-0.5-2.1-1-3.1 -0.3-1-0.9-2-1.5-2.9 -0.6-1-1.3-1.9-2-2.7 -6.8-6.3-17.4-6.3-24.2 0 -0.7 0.8-1.4 1.7-2 2.7 -0.7 0.9-1.2 1.9-1.5 2.9 -0.5 1-0.8 2-1 3.1 -0.2 1.1-0.3 2.3-0.3 3.4 0 4.5 1.7 8.9 4.9 12.1S473.3 443.7 477.9 443.7zM546.1 443.7c4.5 0 8.9-1.7 12.1-4.9s5-7.6 4.9-12.1c0-1.1-0.1-2.3-0.3-3.4 -0.2-1.1-0.5-2.1-1-3.1 -0.3-1-0.9-2-1.5-2.9 -0.6-1-1.3-1.9-2-2.7 -6.8-6.3-17.4-6.3-24.2 0 -0.8 0.8-1.5 1.7-2 2.7 -0.7 0.9-1.2 1.9-1.5 2.9 -0.5 1-0.8 2-1 3.1 -0.2 1.1-0.3 2.3-0.3 3.4 0 4.5 1.7 8.9 4.9 12.1C537.2 441.9 541.6 443.7 546.1 443.7zM602.3 421.7c3.3 3.1 7.6 4.9 12.1 4.9 2.2 0 4.4-0.5 6.5-1.4 2.1-0.8 4-2 5.6-3.6 1.5-1.7 2.7-3.6 3.6-5.6 1.8-4.1 1.8-8.8 0-13 -0.9-2.1-2.1-4-3.6-5.6 -1.6-1.5-3.5-2.8-5.6-3.6 -6.4-2.7-13.7-1.3-18.6 3.6 -1.5 1.7-2.7 3.6-3.6 5.6 -1.8 4.1-1.8 8.8 0 13C599.5 418.1 600.8 420 602.3 421.7z',
	  group: 'M1021.9 891.3l-40.6-141.1c-1-2.9-2.9-5.8-4.8-7.7 -25.1-76.4-87-135.3-165.3-155.6l-11.6-1.9c-17.4-4.8-36.7 1-49.3 15.5 -42.5 48.3-96.6 52.2-153.7 52.2 -57 0-111.1-3.9-153.7-52.2 -12.6-14.5-31.9-20.3-49.3-15.5l-11.6 2.9c-59 15.5-109.2 53.2-141.1 103.4H119.2c-1 0-1 0-1.9-1 0-1-1-1.9-1-3.9l25.1-89.9c22.2-70.6 64.8-91.8 147.9-113.1 3.9-1 6.8-2.9 8.7-4.8 6.8 5.8 14.5 10.6 22.2 14.5 2.9 1.9 5.8 1.9 8.7 1.9 6.8 0 13.5-3.9 17.4-10.6 4.8-9.7 1-21.3-8.7-26.1 -44.5-23.2-76.4-88.9-76.4-156.6 0-59.9 49.3-109.2 109.2-109.2 11.6 0 22.2 1.9 32.9 4.8 -10.6 26.1-16.4 54.1-16.4 84.1 0 165.3 99.5 304.4 217.5 304.4 116 0 218.4-142.1 218.4-304.4 0-120.8-97.6-218.4-218.4-218.4 -76.4 0-144 39.6-182.7 99.5 -16.4-5.8-33.8-8.7-51.2-8.7 -52.2 0-98.6 28-124.7 69.6 -1.9-1.9-3.9-2.9-5.8-3.9 -14.5-7.7-29-10.6-45.4-10.6 -54.1-1-97.6 42.5-97.6 96.6 0 30.9 8.7 59.9 22.2 83.1 -44.5 11.6-84.1 29-102.4 88L1.3 532.8c-2.9 9.7-1 20.3 4.8 28 5.8 8.7 16.4 13.5 27.1 13.5h74.4c-1 3.9-2.9 7.7-3.9 11.6l-25.1 90.8c-3.9 12.6-1 26.1 7.7 36.7 7.7 10.6 19.3 16.4 32.9 16.4h102.4c-2.9 6.8-4.8 13.5-6.8 20.3l-40.6 142.1c-3.9 16.4-1 33.8 9.7 47.4 10.6 13.5 26.1 21.3 42.5 21.3h579.9 32.9 130.5c16.4 0 32.9-7.7 42.5-21.3C1022.9 926.1 1026.8 908.7 1021.9 891.3zM444.9 200.3c1-1 1.9-1.9 2.9-3.9 1-1 1-2.9 1.9-3.9 30-54.1 88-90.8 154.6-90.8 80.2 0 147.9 53.2 171.1 125.6 -33.8 6.8-69.6-6.8-90.8-35.8 -6.8-8.7-18.4-10.6-27.1-3.9 -3.9 2.9-5.8 5.8-6.8 9.7 -1 1-1 1.9-1.9 2.9 -27.1 55.1-117.9 78.3-221.3 58C430.5 238 436.3 218.7 444.9 200.3zM499.1 303.7c77.3 0 141.1-24.2 174-69.6 24.2 21.3 54.1 32.9 86 32.9 7.7 0 16.4-1 24.2-2.9 1 5.8 1 10.6 1 16.4 0 142.1-84.1 266.8-179.8 266.8 -91.8 0-172-115-178.8-250.3C450.7 301.8 475.9 303.7 499.1 303.7zM41 535.7l13.5-48.3c11.6-39.6 35.8-51.2 84.1-62.8 2.9-1 5.8-1.9 7.7-3.9 4.8 3.9 8.7 6.8 14.5 9.7 2.9 1.9 5.8 1.9 8.7 1.9 6.8 0 13.5-3.9 17.4-10.6 4.8-9.7 1-21.3-7.7-26.1 -25.1-13.5-43.5-51.2-43.5-89.9 0-32.9 26.1-59 59-59 10.6 0 19.3 1.9 28 6.8 2.9 1 4.8 1.9 7.7 1.9 -4.8 14.5-7.7 30-7.7 46.4 0 55.1 18.4 109.2 47.4 146.9 -58 14.5-109.2 33.8-143 87H41L41 535.7zM982.3 916.5c-1.9 1.9-5.8 5.8-12.6 5.8H839.3h-32.9H226.5c-6.8 0-10.6-3.9-12.6-5.8 -2.9-3.9-3.9-9.7-2.9-13.5l40.6-141.1C271 695.1 324.1 643 391.8 625.6l11.6-2.9c2.9-1 7.7 1 10.6 3.9 53.2 60.9 118.9 65.7 182.7 65.7s129.5-4.8 182.7-65.7c2.9-2.9 6.8-4.8 11.6-3.9l11.6 2.9c66.7 17.4 120.8 69.6 140.1 136.3l17.4 59.9c1 2.9 1.9 4.8 3.9 6.8l21.3 73.5C986.2 906.8 985.2 912.6 982.3 916.5z',
	  house: 'M855.2 502.4c-16.6 0-29.5 12.8-29.5 29.5v403.4H616.4V770.6c0-15.5-12.9-29-28.4-29H436.6c-16.6 0-30.1 13.5-30.1 29v164.7H197.8v-390c0-15.6-12.9-28.5-29.5-28.5 -15.6 0-28.4 12.9-28.4 28.5v419.6c0 15.6 12.9 28.5 28.4 28.5h268.3c15.6 0 28.4-12.9 28.4-28.5V800.1h93.4v164.7c0 15.6 12.9 28.5 29.5 28.5h267.2c15.6 0 28.4-12.9 28.4-28.5v-433C883.6 515.2 870.8 502.4 855.2 502.4zM1015.6 525.4L782.8 291.5V132c0-16.6-13.4-29.4-30.1-29.4 -15.6 0-28.4 12.8-28.4 29.4v101L532.2 39.8c-5.9-6-12.9-9.2-19.9-9.2 -8 0-15 3.3-20.9 9.2L9 522.2C-2.6 533.8-3.3 552.3 9 563c10.7 12.4 29.2 11.6 40.8 0l462.6-461.5 461.5 465.8c4.8 4.8 11.8 7.6 20.9 7.6 8 0 15-2.7 20.9-7.6C1026.4 556.5 1027.2 537.1 1015.6 525.4z',
	  kayak: 'M1001.6 473c-14.2-12-32.8-17.2-51.3-14.1l-85 14.1c-18.2 3-32.4 15.7-38.1 32.3H702.3c-1.3-272-81.4-484.1-183.5-484.1 -102.1 0-182.2 212.1-183.5 484.1H196.8c-5.7-16.6-20-29.3-38.2-32.3l-84.9-14.1c-18.4-3-37.1 2.1-51.3 14.1C8.2 485.1 0 502.7 0 521.4c0 18.6 8.2 36.2 22.4 48.3 11.5 9.8 26 15 40.8 15 3.5 0 7-0.3 10.5-0.9l85-14.1c18.2-3 32.4-15.7 38.1-32.3h138.6c4.8 263 83.6 465.5 183.3 465.5 99.8 0 178.6-202.5 183.4-465.5h125.1c5.7 16.6 20 29.3 38.2 32.3l85 14.1c3.5 0.6 7 0.9 10.5 0.9 14.9 0 29.3-5.2 40.8-15 14.2-12 22.4-29.6 22.4-48.4C1024 502.7 1015.8 485.1 1001.6 473zM518.8 53.2c88.4 0 150.3 236.9 151.5 452.1h-52c-4.3-95.2-46.4-167.6-99.6-167.6 -53.1 0-95.2 72.4-99.6 167.6h-52C368.5 290 430.3 53.2 518.8 53.2zM451.2 505.3c4-80.7 37.4-135.6 67.6-135.6 30.2 0 63.6 54.9 67.6 135.6H451.2zM586.3 537.3c-4 80.7-37.4 135.6-67.6 135.6 -30.2 0-63.6-54.9-67.6-135.6H586.3zM153.4 538.1l-85 14.1h0c-9 1.5-18.3-1-25.4-7 -7-6-11.1-14.7-11.1-24 0-9.2 4-17.9 11.1-23.9 5.7-4.8 12.9-7.4 20.2-7.4 1.7 0 3.5 0.1 5.2 0.4l85 14.1c8.2 1.4 14.2 8.4 14.2 16.8C167.6 529.7 161.6 536.7 153.4 538.1zM518.8 970.8c-85.9 0-146.7-223.4-151.3-433.5h51.7c4.3 95.2 46.4 167.6 99.6 167.6s95.3-72.4 99.6-167.6H670C665.5 747.4 604.6 970.8 518.8 970.8zM980.9 545.2c-7 6-16.2 8.5-25.4 7 0 0 0 0 0 0l-84.9-14.1c-8.2-1.4-14.2-8.4-14.2-16.8 0-8.3 6-15.4 14.2-16.7l85-14.1c1.7-0.3 3.5-0.4 5.2-0.4 7.3 0 14.5 2.6 20.2 7.4 7 6 11.1 14.7 11.1 24C992 530.6 988 539.3 980.9 545.2z',
	  mail: 'M829.1 710.3c-4.1 0-8.1-1.5-11.3-4.5l-190-178.2c-6.6-6.2-7-16.7-0.7-23.3 6.2-6.7 16.6-7 23.3-0.7l190 178.2c6.6 6.2 7 16.7 0.7 23.3C837.9 708.5 833.5 710.3 829.1 710.3zM194.9 710.3c-4.4 0-8.8-1.8-12.1-5.2 -6.2-6.6-5.9-17.1 0.7-23.3l190.1-178.2c6.7-6.2 17.1-5.9 23.3 0.7 6.2 6.6 5.9 17.1-0.7 23.3L206.2 705.8C203 708.8 198.9 710.3 194.9 710.3zM941.5 876H82.5C37 876 0 839 0 793.4V230.6C0 185 37 148 82.5 148h858.9c45.5 0 82.5 37 82.5 82.5v562.9C1024 839 987 876 941.5 876zM82.5 181C55.2 181 33 203.3 33 230.6v562.9c0 27.3 22.2 49.5 49.5 49.5h858.9c27.3 0 49.5-22.2 49.5-49.5V230.6c0-27.3-22.2-49.5-49.5-49.5H82.5zM512 595c-22 0-43.9-7.3-60.6-21.9l-424-369.9c-6.9-6-7.6-16.4-1.6-23.3 6-6.9 16.4-7.5 23.3-1.6l424 369.8c21.1 18.4 56.8 18.4 77.8 0l423.4-369.2c6.8-6 17.2-5.3 23.3 1.6 6 6.9 5.3 17.3-1.6 23.3L572.6 573.1C555.9 587.7 534 595 512 595z',
	  mappin: 'M515.3 224.4c-72.2 0-130.9 58.7-130.9 130.9s58.7 130.9 130.9 130.9 130.9-58.7 130.9-130.9S587.5 224.4 515.3 224.4zM515.3 448.8c-51.6 0-93.5-41.9-93.5-93.5s41.9-93.5 93.5-93.5 93.5 41.9 93.5 93.5S566.9 448.8 515.3 448.8zM765.6 105C697.9 37.3 607.8 0 512 0c-95.8 0-185.8 37.3-253.6 105 -125.4 125.3-140.9 361.1-33.7 504L512 1024l286.9-414.4C906.5 466.2 891 230.4 765.6 105zM768.6 587.8L512 958.3l-257-371.1c-97.2-129.6-83.3-342.6 29.8-455.7C345.6 70.8 426.2 37.4 512 37.4s166.5 33.4 227.1 94.1C852.3 244.6 866.2 457.6 768.6 587.8z',
	  motorbike: 'M857.2 460.5c-22.5 0-43.9 4.5-63.5 12.6l-9.2-17.3c22.6-9.6 47.2-14.8 72.8-14.8 31.8 0 63.3 8.2 90.9 23.7 7.9 4.4 17.9 1.6 22.4-6.3 4.4-7.9 1.6-17.9-6.3-22.4 -32.5-18.3-69.5-27.9-107-27.9 -31.1 0-61 6.6-88.3 18.6l-16.3-30.5c1.5 0.1 3.1 0.2 4.6 0.2h38.1c9.1 0 16.4-7.4 16.4-16.4V273.7c0-9.1-7.4-16.4-16.4-16.4h-38.1c-25.8 0-48.2 14.5-59.6 35.8l-29-54.4c-2.9-5.4-8.4-8.7-14.5-8.7h-77.4c-9.1 0-16.4 7.4-16.4 16.4s7.4 16.4 16.4 16.4h67.6l27.9 52.4c-3.6-2.6-7.4-5.1-11.5-7.2 -24.8-13-54.7-13.8-80.1-2l-51.2 23.7c-18.5 8.6-33 22.7-42.2 39.7 -14.7-16.3-35.2-27.4-58.5-30.1l-249.5-28.2c-12.7-1.4-25.5 2.6-35.1 11.2 -9.6 8.5-15 20.8-15 33.6V428c-3.1 1.4-6.2 2.8-9.3 4.4C63.1 461.6 21.9 513.8 6.9 575.5c-2.1 8.8 3.3 17.7 12.1 19.9 1.3 0.3 2.6 0.5 3.9 0.5 7.4 0 14.1-5 16-12.6 12.8-52.4 47.7-96.8 96-121.6 17.2-8.9 37-13.6 57.1-13.6h22.7 263.6v47.7H322c-28.3-22-63.7-35.2-102.1-35.2 -85.7 0-156.9 65.5-165.8 149H16.4C7.4 609.5 0 616.9 0 626v54.7c0 9.1 7.4 16.4 16.4 16.4h52c27 58.5 86.5 97 151.5 97s124.5-38.5 151.5-97h113.3c35.9 0 65.4-27.5 68.7-62.5 30.5-11 56.4-32.9 72.2-62.6l77.9-152c4.4-11.7 6.2-23.8 5.7-35.7l30.9 57.9c-41.2 26.1-73.6 65.9-90.1 114.3 -2.9 8.6 1.6 17.9 10.2 20.9 1.8 0.6 3.6 0.9 5.3 0.9 6.8 0 13.2-4.3 15.6-11.1 13.8-40.4 40.5-73.6 74.5-95.9l9.2 17.3c-44.7 29.9-74.2 80.9-74.2 138.6 0 92 74.8 166.8 166.8 166.8S1024 719.3 1024 627.3 949.2 460.5 857.2 460.5zM214.7 415.2L214.7 415.2l-22.7 0h-30v-59.4c0-4.7 2.5-7.7 4.1-9.1 1.5-1.4 4.8-3.5 9.5-3L425 371.9c24.7 2.8 44.5 20.3 51 43.2L214.7 415.2 214.7 415.2zM421 528.6l42.1 80.9h-77.4c-3.2-30.1-14.5-57.7-31.6-80.9H421L421 528.6zM219.9 493.4c67.6 0 123.9 50.7 132.6 116.1H87.2C96 544.2 152.3 493.4 219.9 493.4zM219.9 761.2c-46.9 0-90.2-25-114.2-64.1h20.8c22 29.5 56.3 46.9 93.4 46.9 37.1 0 71.4-17.4 93.4-46.9h20.8C310.1 736.2 266.8 761.2 219.9 761.2zM173.6 697.1h92.7c-13.5 9-29.5 14-46.3 14C203.1 711.1 187.1 706.1 173.6 697.1zM484.6 664.2H32.9v-21.8h484.9C512.3 655.2 499.5 664.2 484.6 664.2zM596.5 556.6c-17.4 32.7-51.1 53-88.1 53h-8.2l-42.1-80.9h36.7c9.1 0 16.4-7.4 16.4-16.4v-64.1h143L596.5 556.6zM672.6 408.4l-2.5 6.7H509.7c-0.2-1.2-0.5-2.5-0.7-3.7 0.7-22 13.6-42.4 34.3-51.9l51.2-23.7c16.2-7.5 35.2-7 51 1.3C671.2 350.6 682.8 381.3 672.6 408.4zM722.6 328.8v-4c0-19.1 15.6-34.7 34.7-34.7h21.6v73.4h-21.6C738.2 363.6 722.6 348 722.6 328.8zM804.1 562.6l18.2 34.1c3 5.5 8.6 8.7 14.5 8.7 2.6 0 5.3-0.6 7.7-1.9 8-4.3 11-14.2 6.8-22.2l-18.2-34.1c7.6-2.3 15.7-3.6 24.1-3.6 46.2 0 83.8 37.6 83.8 83.8s-37.6 83.8-83.8 83.8 -83.8-37.6-83.8-83.8C773.5 601.3 785.4 578 804.1 562.6zM857.2 761.2c-73.8 0-133.9-60.1-133.9-133.9 0-45.2 22.5-85.2 56.9-109.4l8.2 15.3c-29 21.2-47.8 55.5-47.8 94.1 0 64.3 52.3 116.7 116.7 116.7s116.7-52.3 116.7-116.7 -52.3-116.7-116.7-116.7c-14 0-27.4 2.5-39.8 7l-8.2-15.3c14.9-5.7 31.1-8.9 48-8.9 73.8 0 133.9 60.1 133.9 133.9S931.1 761.2 857.2 761.2zM842.1 633.6C842.2 634 842.2 633.9 842.1 633.6c4.5 10.5 18.7 13.6 26.8 5.3 6.3-6.2 6.3-17.1 0-23.2 -5.4-5.5-14.4-6.3-20.8-2.1C841.6 617.9 839.2 626.3 842.1 633.6 841.9 633.3 841.9 633.1 842.1 633.6z',
	  mountainbikeHelmet: 'M551.3 933.8h30.4v30.4h-30.4V933.8zM551.3 812.1h30.4v30.4h-30.4V812.1zM551.3 872.9h30.4v30.4h-30.4V872.9zM848.6 105.8C798.4 52.7 731.9 17.5 660.5 5.1l-12.9-2.5v0.5c-11.1-1.5-22.2-2.4-33.5-2.8V0l-10.6 0.1c-0.2 0-0.5 0-0.7 0h0c-1.1 0-2.3 0-3.4 0l-0.5 0c-0.1 0-0.2 0-0.3 0 -4.8 0-9.6 0.1-14.4 0.2 -0.8 0-1.5 0-2.3 0.1 -4 0.1-8 0.3-11.9 0.4 -1.4 0.1-2.7 0.1-4.1 0.2 -2.9 0.1-5.8 0.3-8.8 0.5 -2.3 0.1-4.5 0.3-6.8 0.4 -0.1 0-0.1 0-0.2 0 -4.5 0.3-9 0.7-13.4 1.1l-13.8 1.2v0.2c-109.6 12.2-207.3 49.4-280.7 108C143.3 191.2 91 304.2 91 439v15.2h80.3c60.7 0 117.8 32.4 149 84.4 8.5 14.3 22.9 24.1 39 27.1l133.7 137.1v52.9 30.4V1024h143.9V786.1v-30.4 -49.6l139.9-78.2c7.1 1.5 14.4 2.3 21.9 2.3 61.5 0 111.5-49.7 112.1-111 1.8-13.6 19-142.7 21.7-188.5C937.2 248 907.4 168.1 848.6 105.8zM678 40c10.3 2.7 20.5 5.9 30.4 9.6v54.8c0 8.4-6.8 15.2-15.2 15.2 -8.4 0-15.2-6.8-15.2-15.2L678 40 678 40zM575.3 31c2.4-0.1 4.8-0.2 7.2-0.3 0.4 0 0.8 0 1.2 0V68c0 8.4-6.8 15.2-15.2 15.2 -8.4 0-15.2-6.8-15.2-15.2V32.3h0C560.7 31.7 568 31.3 575.3 31zM396.5 560.2c9.5-4.9 17.6-12.4 23.2-21.8l15.3-25.7 152.5 168.7h-72.8L396.5 560.2zM451.2 485.3l15.2-25.6c12.9-21.7 36.6-35.3 61.9-35.3 66.2 0 126.1 39.1 152.7 99.6 3.5 7.9 6.3 14.5 8.5 19.8l-124 67.9L451.2 485.3zM606.5 993.6h-83V786.1h83V993.6zM606.5 755.7h-83v-43.8h83V755.7zM625.3 677.8l-38.7-43L703 571c10.7 17.7 23.8 31.7 38.6 41.6L625.3 677.8zM902.1 328.9c-0.2 4-0.6 8.6-1 13.8h-95.3v30.4h92.3c-1.5 14.2-2.5 23.1-4.4 38.5H893h-87.2v30.4h84.3c-4.9 39.7-9.4 73.3-9.5 74l-0.1 1v1c0 45-36.6 81.7-81.7 81.7 -48 0-72.2-45.8-80.3-65.5 -2.3-5.7-5.6-13.2-9.6-22.4C677.4 440.2 606.6 394 528.3 394c-36 0-69.7 19.2-88.1 50.2l-46.7 78.8c-4.9 8.3-14 13.4-23.6 13.4 -9.6 0-18.6-5.1-23.5-13.3 -36.7-61.2-103.7-99.2-175.1-99.2h-49.7c7.6-240.7 194.9-363.7 401.2-388.5V68c0 25.2 20.5 45.6 45.6 45.6 25.2 0 45.6-20.5 45.6-45.6V30.7c11.2 0.4 22.4 1.5 33.5 3.1v70.7c0 25.2 20.5 45.6 45.6 45.6 25.2 0 45.6-20.5 45.6-45.6V62.2c32.6 16 62.4 37.8 87.6 64.5C879.5 182.8 906.4 254.7 902.1 328.9zM352.6 475.5H383v30.4h-30.4V475.5zM781 539h30.4v30.4H781V539z',
	  nav: 'M0 853.3h1024V739.6H0V853.3zM0 568.9h1024V455.1H0V568.9zM0 170.7v113.8h1024V170.7H0z',
	  nosmoking: 'M1004.3 498H728.6 559.3L998.4 58.8c7.9-7.9 7.9-19.7 0-27.6 -7.9-7.9-19.7-7.9-27.6 0L504.1 498H19.7C7.9 498 0 505.9 0 517.7v118.2c0 11.8 7.9 19.7 19.7 19.7h326.9l-321 321c-7.9 7.9-7.9 19.7 0 27.6 3.9 3.9 7.9 5.9 13.8 5.9s9.8-2 13.8-5.9l348.6-348.6h326.9 275.7c11.8 0 19.7-7.9 19.7-19.7V517.7C1024 505.9 1016.1 498 1004.3 498zM39.4 616.1v-78.8h425.4L386 616.1H39.4zM519.9 537.4h189v78.8H441.1L519.9 537.4zM984.6 616.1H748.3v-78.8h236.3L984.6 616.1 984.6 616.1zM39.4 466.5c11.8 0 19.7-7.9 19.7-19.7 0-92.6 43.3-165.4 98.5-165.4H256c9.8 0 17.7-5.9 19.7-15.8 2-7.9-2-15.8-7.9-19.7 -19.7-15.8-31.5-37.4-31.5-63 0-43.3 35.4-78.8 78.8-78.8 11.8 0 19.7-7.9 19.7-19.7s-7.9-19.7-19.7-19.7c-65 0-118.2 53.2-118.2 118.2 0 21.7 5.9 41.4 15.8 59.1h-55.1c-78.8 0-137.8 88.6-137.8 204.8C19.7 458.6 27.6 466.5 39.4 466.5zM366.3 51c29.5 13.8 47.3 41.4 47.3 72.9 0 43.3-35.4 78.8-78.8 78.8 -11.8 0-19.7 7.9-19.7 19.7 0 9.8 5.9 17.7 13.8 19.7 13.8 3.9 25.6 21.7 25.6 39.4 0 21.7-17.7 39.4-39.4 39.4H196.9c-57.1 0-98.5 53.2-98.5 126 0 11.8 7.9 19.7 19.7 19.7s19.7-7.9 19.7-19.7c0-49.2 25.6-86.6 59.1-86.6h118.2c43.3 0 78.8-35.4 78.8-78.8 0-15.8-5.9-33.5-15.8-47.3 43.3-17.7 74.8-61 74.8-110.3 0-47.3-27.6-88.6-70.9-108.3 -9.8-3.9-21.7 0-25.6 9.8C352.5 35.2 356.4 47 366.3 51z',
	  phone: 'M809.7 634.5c-21-21.9-46.3-33.5-73.2-33.5 -26.6 0-52.2 11.5-74 33.3l-68.4 68.2c-5.6-3-11.3-5.8-16.7-8.7 -7.8-3.9-15.2-7.6-21.4-11.5C492 641.7 433.8 588.6 377.9 520c-27.1-34.2-45.2-63-58.4-92.2 17.7-16.2 34.2-33.1 50.2-49.3 6.1-6.1 12.1-12.3 18.2-18.4 45.5-45.5 45.5-104.3 0-149.8l-59.1-59.1c-6.7-6.7-13.6-13.6-20.1-20.6 -13-13.4-26.6-27.3-40.7-40.3 -21-20.8-46.1-31.8-72.5-31.8s-51.9 11-73.6 31.8c-0.2 0.2-0.2 0.2-0.4 0.4l-73.6 74.2c-27.7 27.7-43.5 61.5-47 100.6 -5.2 63.2 13.4 122.1 27.7 160.6 35.1 94.6 87.4 182.2 165.6 276.2C289 815.7 403 905.1 533.3 968c49.8 23.6 116.2 51.5 190.5 56.3 4.5 0.2 9.3 0.4 13.6 0.4 50 0 92-18 124.9-53.7 0.2-0.4 0.6-0.6 0.9-1.1 11.3-13.6 24.2-26 37.9-39.2 9.3-8.9 18.8-18.2 28.1-27.9 21.4-22.3 32.7-48.3 32.7-74.9 0-26.8-11.5-52.6-33.3-74.2L809.7 634.5zM887.2 862.4C887 862.4 887 862.6 887.2 862.4c-8.4 9.1-17.1 17.3-26.4 26.4 -14.1 13.4-28.4 27.5-41.8 43.3 -21.9 23.4-47.6 34.4-81.4 34.4 -3.2 0-6.7 0-10-0.2 -64.3-4.1-124-29.2-168.8-50.6 -122.5-59.3-230.1-143.5-319.5-250.2 -73.8-89-123.2-171.2-155.8-259.5 -20.1-53.9-27.5-95.9-24.2-135.5 2.2-25.3 11.9-46.3 29.9-64.3l73.8-73.8c10.6-10 21.9-15.4 32.9-15.4 13.6 0 24.7 8.2 31.6 15.2 0.2 0.2 0.4 0.4 0.6 0.6 13.2 12.3 25.8 25.1 39 38.7 6.7 6.9 13.6 13.9 20.6 21l59.1 59.1c22.9 22.9 22.9 44.2 0 67.1 -6.3 6.3-12.3 12.6-18.6 18.6 -18.2 18.6-35.5 35.9-54.3 52.8 -0.4 0.4-0.9 0.6-1.1 1.1 -18.6 18.6-15.2 36.8-11.3 49.1 0.2 0.6 0.4 1.3 0.6 1.9 15.4 37.2 37 72.3 69.9 114.1l0.2 0.2C392 630.2 455 687.5 524.5 731.5c8.9 5.6 18 10.2 26.6 14.5 7.8 3.9 15.2 7.6 21.4 11.5 0.9 0.4 1.7 1.1 2.6 1.5 7.4 3.7 14.3 5.4 21.4 5.4 18 0 29.2-11.3 32.9-14.9l74-74c7.4-7.4 19-16.2 32.7-16.2 13.4 0 24.5 8.4 31.2 15.8 0.2 0.2 0.2 0.2 0.4 0.4L887 794.7C909.3 816.7 909.3 839.5 887.2 862.4zM553.5 243.2c56.7 9.5 108.2 36.4 149.3 77.5s67.7 92.6 77.5 149.3c2.4 14.3 14.7 24.2 28.8 24.2 1.7 0 3.2-0.2 5-0.4 16-2.6 26.6-17.7 24-33.8 -11.7-68.6-44.2-131.2-93.7-180.7 -49.6-49.6-112.1-82-180.7-93.7 -16-2.6-31 8-33.8 23.8S537.4 240.6 553.5 243.2zM1023.6 451.6c-19.3-113-72.5-215.8-154.3-297.6S684.6 19 571.6-0.3c-15.8-2.8-30.7 8-33.5 23.8 -2.6 16 8 31 24 33.8C663 74.4 755 122.2 828.1 195.1c73.2 73.2 120.8 165.1 137.9 266 2.4 14.3 14.7 24.2 28.8 24.2 1.7 0 3.2-0.2 5-0.4C1015.5 482.6 1026.4 467.4 1023.6 451.6z',
	  racebikeHelmet: 'M1023 411.3c-1.2-3.2-30-79.4-105.8-157.2 -44.5-45.6-96-82.3-153-108.9C693 112.1 613 94.5 526.3 93c-209.3-3.5-339.5 80.4-411.7 151.5C40.1 317.7 0 405.4 0 450.9c0 49.9 28.5 98.3 45.6 122.8 26.1 37.5 57.9 66.4 82.9 75.3 4.9 1.8 10.7 2.6 17.4 2.6 16.8 0 39.3-5.2 68-14L333 718.9c2.6 1.8 5.6 2.7 8.6 2.7 4.9 0 9.6-2.3 12.6-6.6 4.7-6.9 3-16.4-4-21.1l-99.7-68.2c9.8-3.3 20.2-6.9 31.1-10.7l180.9 123.6c2.6 1.8 5.6 2.7 8.6 2.7 3.7 0 7.4-1.3 10.3-4L642.4 590c13.3-0.2 26.9-0.6 40.6-1.4L474.7 778.9l-71-48.5c-6.9-4.7-16.4-3-21.1 4 -4.7 6.9-3 16.4 4 21.1l253 172.9c2.6 1.8 5.6 2.7 8.6 2.7 3.7 0 7.4-1.3 10.3-4l43-39.3c3.4-3.1 5.2-7.7 4.9-12.3 -0.3-4.6-2.8-8.9-6.6-11.5L543.5 757.2l189.2-172.9c143.6-17 241-70.9 289.4-160.5C1024.3 420 1024.6 415.4 1023 411.3zM666.7 878.3l-20 18.3 -146.3-100 20-18.3L666.7 878.3zM469.6 706.7L317.3 602.6c46.1-15.7 91.8-29.8 113.8-27.6 4.5 0.5 11 1.3 19.1 2.3 29.8 3.7 84 10.5 147.6 12.3L469.6 706.7zM735.7 426.1c-8.4 0.4-14.9 7.5-14.5 15.8 0.3 8.2 7.1 14.5 15.2 14.5 0.2 0 0.4 0 0.7 0 79.1-3.4 158.9-8.6 237.7-15.6 -48.9 62.3-132.4 100.5-249 113.7 -111.2 12.6-223.7-1.5-271.8-7.5 -8.4-1-15-1.9-19.9-2.4 -33.7-3.4-94.4 17.7-158.6 40.1 -50.5 17.6-119.6 41.6-136.8 35.5C103 607.6 30.4 521.1 30.4 450.9c0-3.3 0.3-7 1-11.1C189.7 454.1 350 461.4 510 461.4c54.1 0 108.2-0.8 162.2-2.5 8.4-0.3 15-7.3 14.7-15.7 -0.3-8.4-7.2-15-15.7-14.7 -210.5 6.5-423 0.2-631.9-18.6 11-30.6 32.3-70.1 65.2-109.7 51.9-33.3 110.8-59.4 175.2-77.4 75.8-21.2 159.6-31.3 248.9-30.1 80.3 1.1 155.9 12.1 224.7 32.7 8 2.4 16.5-2.2 18.9-10.2 2.4-8-2.2-16.5-10.2-18.9 -71.5-21.4-149.9-32.8-233-34 -92.3-1.3-178.9 9.2-257.5 31.2 -29.5 8.3-57.9 18.1-85.1 29.6 70.8-52.2 176.7-99.7 327.1-99.7 4 0 8.1 0 12.1 0.1 82.1 1.4 157.7 17.9 224.9 49 53.7 24.9 102.1 59.2 144 102 53.9 55 83.1 110.3 94.4 134.6C905.1 416.7 820 422.5 735.7 426.1zM937.8 361.1C825 287 687.5 248.4 529.1 246.1c-92.3-1.3-178.9 9.2-257.5 31.2 -8.1 2.3-12.8 10.6-10.5 18.7s10.6 12.8 18.7 10.5c75.8-21.2 159.6-31.3 248.9-30.1 152.5 2.1 284.5 39.1 392.4 110 2.6 1.7 5.5 2.5 8.3 2.5 4.9 0 9.8-2.4 12.7-6.9C946.8 375.2 944.8 365.7 937.8 361.1zM241 302.5c-2.8-7.9-11.5-12-19.4-9.2 -48.7 17.5-94.3 39.8-135.3 66.4 -7 4.6-9.1 14-4.5 21 2.9 4.5 7.8 6.9 12.8 6.9 2.8 0 5.7-0.8 8.3-2.4 39.1-25.3 82.5-46.6 129-63.3C239.7 319.1 243.8 310.4 241 302.5z',
	  sign: 'M1013 542.2L831.7 399.9c-4-4-9.5-6-16-6H539.5v-50.9h305.7c15.5 0 27.5-12.5 27.5-28V29.7c0-15.5-12-27.5-27.5-27.5H208.8c-6.5 0-12.5 2-17.5 6L10.5 150.6C3.2 156.3 0 164.1 0 173.1c0 8.5 3.2 15.8 10.5 21.5l180.8 141.9c5.6 4.4 11 6.5 17.5 6.5H484v50.9H179.3c-7.5 0-14 2.5-19.5 8 -5.5 5.5-8.5 12-8.5 19.5v285.7c0 15.5 12.5 27.5 28 27.5H484v259.7c0 15.5 12 27.5 27.5 27.5 15.5 0 28-12 28-27.5V734.5h276.2c6.5 0 12-2 16-6L1013 586.2c7.3-5.7 11-13 11-22.5C1024 554.7 1020.3 548 1013 542.2zM217.8 287.5L72.9 173.1 217.8 57.2h599.9v230.3H539.5 484L217.8 287.5 217.8 287.5zM805.2 679.1H539.5 484 206.8V449.3H484h55.4 265.7l146.4 114.4L805.2 679.1z',
	  skis: 'M1019.2 159.4c-5-7.5-13.6-11.7-23.5-11.7 -5.4 0-11.3 1.3-17.5 3.7l-58.4 23.4c-20 8-47.5 26.2-62.7 41.4L537.3 535.9c-18.6 2.6-35.7 11.1-49.2 24.6 -6.8 6.8-6.8 17.8 0 24.6l0 0L162.9 910.3c-9.8 9.8-15.2 22.9-15.2 36.9 0 14 5.4 27.1 15.2 36.9l24.6 24.6c9.8 9.8 22.9 15.2 36.9 15.2 14 0 27.1-5.4 36.9-15.2l325.2-325.2c3.4 3.4 7.8 5.1 12.3 5.1 4.5 0 8.9-1.7 12.3-5.1 13.5-13.5 22-30.6 24.6-49.2l319.8-319.8c15.2-15.2 33.4-42.8 41.4-62.7l23.4-58.4C1027 176.5 1023.4 165.6 1019.2 159.4zM598.8 622l-49.2-49.2 2.9-2.9c12.8 0.7 24.8 6 34 15.2 9.2 9.2 14.5 21.2 15.2 34L598.8 622zM236.7 984.1c-3.3 3.3-7.6 5.1-12.3 5.1 -4.7 0-9-1.8-12.3-5.1l-24.6-24.6c-3.3-3.3-5.1-7.6-5.1-12.3 0-4.7 1.8-9 5.1-12.3L525 597.4l49.2 49.2L236.7 984.1zM964.6 238.8c-6.3 15.7-21.7 39.1-33.7 51.1L630.6 590.2c-4.3-11-10.9-21.1-19.5-29.7 -8.6-8.6-18.7-15.2-29.7-19.5l300.4-300.4c12-12 35.4-27.4 51.1-33.7l53-21.2L964.6 238.8zM488.1 683.5c-3.2-3.2-7.7-5.1-12.3-5.1 -4.6 0-9 1.8-12.3 5.1 -3.2 3.2-5.1 7.7-5.1 12.3 0 4.6 1.9 9 5.1 12.3 3.2 3.2 7.7 5.1 12.3 5.1 4.6 0 9.1-1.9 12.3-5.1s5.1-7.7 5.1-12.3C493.2 691.2 491.3 686.8 488.1 683.5zM451.2 541c4.5 0 8.9-1.7 12.3-5.1 13.5-13.5 22-30.6 24.6-49.2l319.8-319.8c15.2-15.2 33.4-42.8 41.4-62.7l23.4-58.4c6.7-16.8 3.1-27.8-1.1-34C866.5 4.3 858 0 848.1 0c-5.4 0-11.3 1.3-17.5 3.7l-58.4 23.4c-20 8-47.5 26.2-62.7 41.4L389.6 388.4c-18 2.6-35.3 10.7-49.2 24.6 -6.8 6.8-6.8 17.8 0 24.6l0 0L15.2 762.7C5.4 772.6 0 785.7 0 799.6c0 14 5.4 27.1 15.2 36.9l24.6 24.6c9.8 9.8 22.9 15.2 36.9 15.2s27.1-5.4 36.9-15.2l325.2-325.2C442.3 539.3 446.7 541 451.2 541zM404.8 422.4c12.4 0.7 24.6 5.7 34.1 15.1 9.2 9.2 14.5 21.2 15.2 34l-2.9 2.9L402 425.2 404.8 422.4zM734.1 93.1c12-12 35.4-27.4 51.1-33.7l53-21.2 -21.2 53c-6.3 15.7-21.7 39.1-33.7 51.1L483 442.6c-4.3-11-10.9-21.1-19.5-29.7 -8.7-8.7-18.9-15.2-29.8-19.5L734.1 93.1zM89 836.5c-3.3 3.3-7.6 5.1-12.3 5.1s-9-1.8-12.3-5.1l-24.6-24.6c-3.3-3.3-5.1-7.6-5.1-12.3 0-4.7 1.8-9 5.1-12.3l337.5-337.5 49.2 49.2L89 836.5zM340.5 535.9c-3.2-3.2-7.7-5.1-12.3-5.1 -4.6 0-9 1.8-12.3 5.1 -3.2 3.2-5.1 7.7-5.1 12.3 0 4.6 1.9 9 5.1 12.3 3.2 3.2 7.7 5.1 12.3 5.1 4.6 0 9.1-1.8 12.3-5.1 3.2-3.2 5.1-7.7 5.1-12.3C345.5 543.6 343.7 539.2 340.5 535.9z',
	  target: 'M1022.2 101.4c-3.2-6.3-10.1-9.9-17.1-8.8l-87.2 13.4 13.4-87.2c1.1-7-2.5-13.9-8.8-17.1 -6.3-3.2-13.9-2-18.9 3L802.4 106.1c-2.5 2.5-4.1 5.6-4.6 9.1l-16 104 -58 58C643.9 203 540.6 162.3 430.9 162.3c-115.2 0-223.4 44.8-304.7 126.1C44.8 369.8 0 478 0 593.1s44.8 223.4 126.1 304.7c81.3 81.3 189.6 126.1 304.7 126.1s223.4-44.8 304.7-126.1c81.3-81.3 126.1-189.6 126.1-304.7 0-91.6-28.3-179.1-81.9-252.9 -5.3-7.3-15.5-8.9-22.8-3.6 -7.3 5.3-8.9 15.5-3.6 22.8 49.5 68.2 75.7 149 75.7 233.7 0 219.6-178.6 398.2-398.2 398.2S32.7 812.7 32.7 593.1 211.3 195 430.9 195c101 0 196.1 37.3 269.8 105.2L626 374.9c-53.7-48.1-122.5-74.5-195.1-74.5 -161.4 0-292.7 131.3-292.7 292.7s131.3 292.7 292.7 292.7 292.7-131.3 292.7-292.7c0-53.9-14.7-106.5-42.6-152.2 -4.7-7.7-14.8-10.1-22.5-5.4 -7.7 4.7-10.1 14.8-5.4 22.5 24.7 40.6 37.8 87.3 37.8 135.2 0 143.4-116.6 260-260 260 -143.4 0-260-116.6-260-260s116.6-260 260-260c63.9 0 124.5 23 172 64.9L528 472.9c-27.4-22.2-61.3-34.3-97.1-34.3 -85.2 0-154.5 69.3-154.5 154.5s69.3 154.5 154.5 154.5c85.2 0 154.5-69.3 154.5-154.5 0-15.2-2.2-30.2-6.5-44.6 -2.6-8.6-11.7-13.5-20.4-10.9 -8.6 2.6-13.5 11.7-10.9 20.4 3.4 11.4 5.1 23.2 5.1 35.2 0 67.2-54.7 121.8-121.8 121.8S309 660.3 309 593.2c0-67.2 54.7-121.8 121.8-121.8 27.1 0 52.7 8.8 73.8 24.9l-85.4 85.4c-6.4 6.4-6.4 16.7 0 23.1 3.2 3.2 7.4 4.8 11.6 4.8 4.2 0 8.4-1.6 11.6-4.8l293.1-293.1c0.1-0.1 69.3-69.3 69.3-69.3l104-16c3.4-0.5 6.6-2.1 9.1-4.6l101.3-101.3C1024.2 115.3 1025.4 107.7 1022.2 101.4L1022.2 101.4zM829.3 125.4l62.2-62.2 -8.4 54.6L820.9 180 829.3 125.4zM898.6 194.7l-54.6 8.4 62.2-62.2 54.6-8.4C960.8 132.5 898.6 194.7 898.6 194.7z',
	  tree: 'M585.1 1024H438.9V831.7H135l220.3-293.9H205.9l174-232.2h-96.9L512 0l228.9 305.5H644l174.1 232.2H668.7L889 831.7H585.1C585.1 831.7 585.1 1024 585.1 1024zM481.7 981.2h60.5V788.8h261.1L583 494.9h149.4l-174-232.2h96.9L512 71.5 368.7 262.7h96.9l-174 232.2h149.4L220.6 788.8h261.1C481.7 788.8 481.7 981.2 481.7 981.2z',
	  twitter: 'M1018.1 188.8c-5.2-5.2-13.9-7-20.9-5.2l-34.8 12.2c20.9-24.3 34.8-50.4 43.5-74.7 3.5-8.7 1.7-15.6-3.5-20.9 -5.2-5.2-13.9-7-20.9-3.5 -48.7 20.9-90.4 38.2-125.1 48.7 0 1.7-1.7 0-3.5 0 -27.8-15.6-95.6-50.4-144.3-50.4 -123.4 1.7-222.5 106-222.5 232.9v7C305.5 300 206.5 247.8 98.7 134.9l-17.4-17.4 -10.4 20.9c-59.1 113-17.4 215.5 50.4 285C90 418.2 69.1 407.8 50 392.1c-7-5.2-15.6-7-24.3-1.7 -7 3.5-10.4 13.9-8.7 22.6 24.3 81.7 85.2 147.7 151.2 187.7 -31.3 0-57.4-3.5-83.4-20.9 -7-3.5-17.4-3.5-24.3 1.7s-10.4 13.9-7 22.6c31.3 88.6 92.1 135.6 189.5 147.7 -50.4 29.5-116.5 53.9-219 55.6 -10.4 0-19.1 7-22.6 15.6 -3.5 10.4 0 19.1 7 26.1 62.6 50.4 201.6 80 373.7 80 305.9 0 556.2-272.9 556.2-608.3v-5.2c38.2-19.1 69.5-55.6 85.2-106C1025.1 202.7 1023.3 194 1018.1 188.8zM913.8 287.8l-10.4 3.5v29.5c0 316.3-234.6 573.6-521.4 573.6 -158.2 0-264.2-26.1-321.5-53.9 119.9-8.7 189.5-46.9 243.3-88.6l43.5-31.3h-52.1c-99.1 0-159.9-27.8-194.7-93.9 31.3 10.4 64.3 10.4 100.8 8.7 13.9-1.7 27.8-1.7 41.7-1.7l5.2-34.8c-66-19.1-144.3-78.2-182.5-158.2 34.8 15.6 73 19.1 107.8 19.1h53.9l-43.4-31.3c-36.5-26.1-144.3-118.2-92.1-250.3C203 287.8 309 338.2 500.2 373l20.9 3.5v-48.7c0-107.8 83.4-196.4 187.7-198.1 40-1.7 106 34.8 125.1 45.2 10.4 5.2 20.9 7 31.3 3.5 26.1-8.7 57.4-20.9 92.1-34.8 -15.6 26.1-36.5 50.4-64.3 73 -7 5.2-8.7 15.6-5.2 24.3 3.5 8.7 13.9 12.2 22.6 8.7l67.8-22.6C966 249.6 946.9 275.7 913.8 287.8z',
	  whatsapp: 'M512 0C229.7 0 0 229.7 0 512c0 96.3 26.8 189.8 77.5 271 -20.2 70.9-56.8 204.9-57.1 206.3 -1.9 6.9 0.1 14.3 5.3 19.3s12.7 6.8 19.5 4.7l202.9-62.4c79.5 47.9 170.5 73.2 263.9 73.2 282.3 0 512-229.7 512-512S794.3 0 512 0zM512 984.5c-89 0-175.7-24.9-250.7-71.9 -3.2-2-6.8-3-10.5-3 -1.9 0-3.9 0.3-5.8 0.9L67.8 965c13-47.5 36.4-132.5 50-179.8 1.6-5.5 0.7-11.4-2.4-16.2 -49.7-76.5-76-165.5-76-257.2 0-260.6 212-472.6 472.6-472.6s472.6 212 472.6 472.6S772.6 984.5 512 984.5zM846.5 632.5c-36.4-20.2-67.3-40.4-89.9-55.2 -17.3-11.3-29.7-19.4-38.9-24 -25.5-12.7-44.9-3.7-52.3 3.7 -0.9 0.9-1.8 1.9-2.5 3 -26.5 39.8-61.2 77.9-71.3 79.9 -11.7-1.8-66.6-33-121.1-78.4 -55.7-46.4-90.7-90.8-95.8-121 35.7-36.7 48.6-59.9 48.6-86.2 0-27.1-63.3-140.3-74.7-151.8 -11.5-11.5-37.3-13.3-76.9-5.4 -3.8 0.8-7.3 2.6-10.1 5.4 -4.6 4.9-116.6 119-63.4 257.4 58.4 151.8 208.3 328.3 399.5 357 21.7 3.2 42.1 4.9 61.1 4.9 112.4 0 178.8-56.6 197.5-168.8C857.7 644.8 853.8 636.6 846.5 632.5zM603.5 778C401.4 747.7 274.1 547.4 235 445.9c-38.8-100.8 32.7-190.7 50.7-211 14.6-2.5 30-3.5 36.4-2.5 13.4 18.6 59.8 106.4 61.9 122.2 0 10.3-3.4 24.7-43.5 64.8 -3.7 3.7-5.8 8.7-5.8 13.9 0 103.1 217.5 246.2 256 246.2 33.5 0 77.2-56.3 102-93 1.4 0.1 3.9 0.6 7.3 2.3 7.1 3.6 19.4 11.6 34.9 21.7 20.5 13.4 47.8 31.2 80 49.7C800.4 730.3 759.5 801.4 603.5 778z',
	  wifi: 'M798.6 555.2c-0.3-11.8-5.6-23.1-14.4-30.9C709.3 457.7 612.7 421 512 421s-197.3 36.7-272.2 103.3c-8.8 7.8-14 19.1-14.4 30.9 -0.3 11.9 4.3 23.5 12.7 31.9l82.2 82.2c16 16 41.1 17.1 58.4 2.5 37.1-31.2 84.4-48.4 133.2-48.4 48.8 0 96.1 17.2 133.2 48.4 8.1 6.9 18 10.2 27.8 10.2 11.1 0 22.1-4.3 30.6-12.8l82.2-82.2C794.3 578.7 798.9 567.1 798.6 555.2zM673.1 638.8L673.1 638.8C628.2 601 571 580.2 512 580.2c-59 0-116.2 20.8-161 58.6l-82.4-82.1c66.9-59.6 153.3-92.4 243.4-92.4s176.5 32.8 243.3 92.3L673.1 638.8zM576.4 766c-17.2-17.2-40.1-26.7-64.4-26.7 -24.3 0-47.2 9.5-64.4 26.7 -35.5 35.5-35.5 93.3 0 128.8 17.7 17.7 41.1 26.6 64.4 26.6 23.3 0 46.6-8.9 64.4-26.6 17.2-17.2 26.7-40.1 26.7-64.4C603 806.1 593.6 783.2 576.4 766zM545.8 864.2c-18.6 18.6-48.9 18.6-67.6 0 -18.6-18.6-18.6-48.9 0-67.6 9-9 21-14 33.8-14 12.8 0 24.8 5 33.8 14 0 0 0 0 0 0 9 9 14 21 14 33.8C559.8 843.2 554.8 855.2 545.8 864.2zM1010.3 299.4C730.9 37 293.1 37 13.7 299.4c-8.7 8.1-13.5 19.1-13.7 31 -0.2 11.8 4.3 22.9 12.7 31.2l82.1 82.1c16.5 16.5 42.8 17 59.9 1.2C251.9 354.7 378.8 305 512 305c133.2 0 260.1 49.7 357.3 139.9 8.3 7.7 18.8 11.6 29.3 11.6 11.1 0 22.1-4.3 30.6-12.7l82.1-82.1c8.3-8.3 12.8-19.4 12.7-31.2C1023.8 318.6 1018.9 307.6 1010.3 299.4zM898.7 413.2C793.5 315.6 656.2 261.8 512 261.8c-144.2 0-281.5 53.8-386.7 151.4l-82-82.2c262.8-246.8 674.5-246.8 937.3 0l0.1 0.1L898.7 413.2z'
	};
	
	exports.default = icons;
	module.exports = exports['default'];

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(36);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Button = __webpack_require__(26);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(27);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _localization = __webpack_require__(188);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	var _navigation = __webpack_require__(105);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _common = __webpack_require__(28);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _NavigationModule = __webpack_require__(301);
	
	var _NavigationModule2 = _interopRequireDefault(_NavigationModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navigation = function (_Component) {
	  _inherits(Navigation, _Component);
	
	  function Navigation() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Navigation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      navigationOpen: false
	    }, _this._toggleNavigation = function (state) {
	      _this.setState({ navigationOpen: state || !_this.state.navigationOpen });
	    }, _this._renderNavItems = function () {
	      var language = _this.props.language;
	
	
	      return Object.keys(_navigation2.default).map(function (page) {
	        return _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            key: _navigation2.default[page][language],
	            to: '/' + _navigation2.default[page][language].toLowerCase().replace(' ', ''),
	            className: _NavigationModule2.default.menuItem,
	            activeClassName: _NavigationModule2.default.menuItemActive,
	            onClick: function onClick() {
	              _this._toggleNavigation(false);
	            }
	          },
	          _navigation2.default[page][language]
	        );
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Navigation.prototype.render = function render() {
	    var _this2 = this;
	
	    var navigationOpen = this.state.navigationOpen;
	    var language = this.props.language;
	
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'button',
	        {
	          className: [_NavigationModule2.default.navToggle, navigationOpen ? _NavigationModule2.default.navigationOpen : null].join(' '),
	          onClick: function onClick() {
	            _this2._toggleNavigation();
	          }
	        },
	        _react2.default.createElement(_Icon2.default, { size: 24, type: navigationOpen ? 'close' : 'nav' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: [_NavigationModule2.default.mobileWrapper, navigationOpen ? _NavigationModule2.default.navigationOpen : null].join(' ') },
	        _react2.default.createElement(
	          'nav',
	          { className: _NavigationModule2.default.navigation },
	          _react2.default.createElement(
	            'div',
	            { className: _NavigationModule2.default.menu },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                activeClassName: _NavigationModule2.default.menuItemActive,
	                className: _NavigationModule2.default.menuItem,
	                exact: true,
	                onClick: function onClick() {
	                  _this2._toggleNavigation(false);
	                },
	                to: '/'
	              },
	              'Home'
	            ),
	            this._renderNavItems()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _NavigationModule2.default.actions },
	            _react2.default.createElement(
	              'button',
	              {
	                className: [_NavigationModule2.default.actionsItem, language === 'nl' ? _NavigationModule2.default.actionsItemActive : null].join(' '),
	                onClick: function onClick() {
	                  _this2.props.setLanguage('nl');
	                }
	              },
	              'NL'
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: [_NavigationModule2.default.actionsItem, language === 'de' ? _NavigationModule2.default.actionsItemActive : null].join(' '),
	                onClick: function onClick() {
	                  _this2.props.setLanguage('de');
	                }
	              },
	              'DE'
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: [_NavigationModule2.default.actionsItem, language === 'en' ? _NavigationModule2.default.actionsItemActive : null].join(' '),
	                onClick: function onClick() {
	                  _this2.props.setLanguage('en');
	                }
	              },
	              'EN'
	            )
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              inline: true,
	              type: 'anchor',
	              to: _common2.default[language].bookUrl,
	              target: '_blank'
	            },
	            _localization2.default[language].actionBook,
	            ' \xBB'
	          )
	        )
	      )
	    );
	  };
	
	  return Navigation;
	}(_react.Component);
	
	Navigation.propTypes = {
	  language: _propTypes2.default.string.isRequired,
	  setLanguage: _propTypes2.default.func.isRequired
	};
	exports.default = Navigation;
	module.exports = exports['default'];

/***/ }),

/***/ 301:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"src-components-Navigation----Navigation-module---loader---1TbwD","before":"src-components-Navigation----Navigation-module---before---2GXm2","after":"src-components-Navigation----Navigation-module---after---1CEtD","t-body":"src-components-Navigation----Navigation-module---t-body---212X4","t-small":"src-components-Navigation----Navigation-module---t-small---1cfZ1","t-heading-xs":"src-components-Navigation----Navigation-module---t-heading-xs---3bPj0","t-heading-s":"src-components-Navigation----Navigation-module---t-heading-s---2hFVK","t-heading-m":"src-components-Navigation----Navigation-module---t-heading-m---3LLZV","t-heading-l":"src-components-Navigation----Navigation-module---t-heading-l---3FBVv","t-heading-xl":"src-components-Navigation----Navigation-module---t-heading-xl---1xBVd","t-anchors":"src-components-Navigation----Navigation-module---t-anchors---1sSGi","t-buttons":"src-components-Navigation----Navigation-module---t-buttons---FxUYP","t-buttons-large":"src-components-Navigation----Navigation-module---t-buttons-large---2MHPt","t-formLabel":"src-components-Navigation----Navigation-module---t-formLabel---1lQpp","t-formHelper":"src-components-Navigation----Navigation-module---t-formHelper---12EOj","t-formInput":"src-components-Navigation----Navigation-module---t-formInput---p3pbn","t-tableHeading":"src-components-Navigation----Navigation-module---t-tableHeading---1K6iC","t-tableBody":"src-components-Navigation----Navigation-module---t-tableBody---3v3YN","t-opaque":"src-components-Navigation----Navigation-module---t-opaque---1AfDF","t-bold":"src-components-Navigation----Navigation-module---t-bold---3CTxd","t-italic":"src-components-Navigation----Navigation-module---t-italic---2Yhbd","navigation":"src-components-Navigation----Navigation-module---navigation---2-uWj","actions":"src-components-Navigation----Navigation-module---actions---2LI_Z","navToggle":"src-components-Navigation----Navigation-module---navToggle---1APCH","mobileWrapper":"src-components-Navigation----Navigation-module---mobileWrapper---3T3vu","scale-in-center":"src-components-Navigation----Navigation-module---scale-in-center---1v1gx","navigationOpen":"src-components-Navigation----Navigation-module---navigationOpen---3xMiv","menuItem":"src-components-Navigation----Navigation-module---menuItem---ZdMs-","menuItemActive":"src-components-Navigation----Navigation-module---menuItemActive---2v9CY","actionsItem":"src-components-Navigation----Navigation-module---actionsItem---1tgQj","actionsItemActive":"src-components-Navigation----Navigation-module---actionsItemActive---1lEWm","slideInTop":"src-components-Navigation----Navigation-module---slideInTop---1YuZ5","slideInTopMild":"src-components-Navigation----Navigation-module---slideInTopMild---1HuoA","slideInBottom":"src-components-Navigation----Navigation-module---slideInBottom---2aUnn","slideInBottomMild":"src-components-Navigation----Navigation-module---slideInBottomMild---3UcHh","slideOutTop":"src-components-Navigation----Navigation-module---slideOutTop---3DJ3V","slideOutTopMild":"src-components-Navigation----Navigation-module---slideOutTopMild---ramui","slideOutBottom":"src-components-Navigation----Navigation-module---slideOutBottom---57hhA","slideOutBottomMild":"src-components-Navigation----Navigation-module---slideOutBottomMild---1QgqN","shake-horizontal":"src-components-Navigation----Navigation-module---shake-horizontal---3wOEZ"};

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Navigation = __webpack_require__(186);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Navigation2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var localization = {
	  nl: {
	    actionBook: 'Boek via Micazu'
	  },
	  de: {
	    actionBook: 'Buchen mit Micazu'
	  },
	  en: {
	    actionBook: 'Book through Micazu'
	  }
	};
	
	exports.default = localization;
	module.exports = exports['default'];

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(361);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _CookieConsent = __webpack_require__(180);
	
	var _CookieConsent2 = _interopRequireDefault(_CookieConsent);
	
	var _Navigation = __webpack_require__(187);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _ContentBlock = __webpack_require__(10);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	var _ContactForm = __webpack_require__(176);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	var _Icon = __webpack_require__(27);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Footer = __webpack_require__(185);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _CTA = __webpack_require__(173);
	
	var _CTA2 = _interopRequireDefault(_CTA);
	
	var _utils = __webpack_require__(206);
	
	var _common = __webpack_require__(28);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _ogImage = __webpack_require__(413);
	
	var _ogImage2 = _interopRequireDefault(_ogImage);
	
	var _contactInfoBackground = __webpack_require__(411);
	
	var _contactInfoBackground2 = _interopRequireDefault(_contactInfoBackground);
	
	var _contactFormBackground = __webpack_require__(410);
	
	var _contactFormBackground2 = _interopRequireDefault(_contactFormBackground);
	
	var _indexModule = __webpack_require__(304);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	__webpack_require__(357);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TemplateWrapper = function (_Component) {
	  _inherits(TemplateWrapper, _Component);
	
	  function TemplateWrapper() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TemplateWrapper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      language: 'en',
	      loading: true
	    }, _this.componentDidMount = function () {
	      _this._setLanguage();
	      _this.setState({ loading: false });
	    }, _this._setLanguage = function (language) {
	      // Add 10 years to current date
	      var date = new Date();
	      date.setFullYear(date.getFullYear() + 10);
	
	      if (!language) {
	        var langPref = _utils.cookies.get('LOCALE');
	
	        if (langPref) {
	          _this.setState({ language: langPref });
	        } else {
	          var hostname = window.location.href.split('/')[2];
	          var splitHref = hostname.split('.');
	          var domainExt = splitHref[splitHref.length - 1];
	
	          switch (domainExt) {
	            case 'nl':
	              _this.setState({ language: 'nl' });
	              _utils.cookies.set('LOCALE', 'nl', { path: '/', expires: date });
	              break;
	
	            case 'de':
	              _this.setState({ language: 'de' });
	              _utils.cookies.set('LOCALE', 'de', { path: '/', expires: date });
	              break;
	
	            default:
	              _this.setState({ language: 'en' });
	              _utils.cookies.set('LOCALE', 'en', { path: '/', expires: date });
	              break;
	          }
	        }
	      } else {
	        _this.setState({ language: language });
	        _utils.cookies.set('LOCALE', language, { path: '/', expires: date });
	      }
	
	      return true;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TemplateWrapper.prototype.render = function render() {
	    var language = this.state.language;
	
	
	    if (this.state.loading) {
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_reactHelmet2.default, {
	          title: 'Ferienhaus Vulkaneifel Kopp',
	          meta: [{ name: 'description', content: _common2.default[language].metaDescription }, { name: 'keywords', content: _common2.default[language].metaKeywords }, { property: 'og:title', content: 'Ferienhaus Vulkaneifel Kopp' }, { property: 'og:description', content: _common2.default[language].metaDescription }, { property: 'og:image', content: 'https://www.ferienhaus-vek.de' + _ogImage2.default }, { property: 'og:image:width', content: '1200' }, { property: 'og:image:height', content: '1200' }]
	        }),
	        _react2.default.createElement('div', { className: 'loader' })
	      );
	    }
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'Ferienhaus Vulkaneifel Kopp',
	        meta: [{ name: 'description', content: _common2.default[language].metaDescription }, { name: 'keywords', content: _common2.default[language].metaKeywords }, { property: 'og:title', content: 'Ferienhaus Vulkaneifel Kopp' }, { property: 'og:description', content: _common2.default[language].metaDescription }, { property: 'og:image', content: 'https://www.ferienhaus-vek.de' + _ogImage2.default }, { property: 'og:image:width', content: '1200' }, { property: 'og:image:height', content: '1200' }]
	      }),
	      _react2.default.createElement(_CookieConsent2.default, { cookies: _utils.cookies, language: language }),
	      _react2.default.createElement(
	        'div',
	        { className: _indexModule2.default.wrapper },
	        _react2.default.createElement(_Navigation2.default, { language: language, setLanguage: this._setLanguage }),
	        this.props.children(_extends({}, this.props, { language: language })),
	        _react2.default.createElement(
	          _ContentBlock2.default,
	          { split: true, antiReverse: true, darkBackgroundLeft: true },
	          _react2.default.createElement(
	            'div',
	            { style: { backgroundImage: 'url(' + _contactInfoBackground2.default + ')' } },
	            _react2.default.createElement(
	              'h2',
	              { className: 't-heading-s' },
	              _common2.default[language].contactInfoTitle
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _indexModule2.default.contactInfoBlock },
	              _react2.default.createElement(_Icon2.default, { type: 'mappin', size: 24 }),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Ferienhaus Vulkaneifel Kopp',
	                _react2.default.createElement('br', null),
	                'Dorfstra\xDFe 1',
	                _react2.default.createElement('br', null),
	                '54574 Kopp',
	                _react2.default.createElement('br', null),
	                _common2.default[language].germany
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _indexModule2.default.contactInfoBlock },
	              _react2.default.createElement(_Icon2.default, { type: 'phone', size: 24 }),
	              _react2.default.createElement(
	                'p',
	                null,
	                '+31 (0)6 10 18 64 78'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { backgroundImage: 'url(' + _contactFormBackground2.default + ')' } },
	            _react2.default.createElement(
	              'h2',
	              { className: 't-heading-s' },
	              _common2.default[language].contactFormTitle
	            ),
	            _react2.default.createElement(_ContactForm2.default, { language: this.state.language })
	          )
	        ),
	        _react2.default.createElement(_CTA2.default, { language: this.state.language }),
	        _react2.default.createElement(_Footer2.default, { language: this.state.language })
	      )
	    );
	  };
	
	  return TemplateWrapper;
	}(_react.Component);
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"src-layouts----index-module---loader---wLwNT","before":"src-layouts----index-module---before---1klT6","after":"src-layouts----index-module---after---3NAXm","t-body":"src-layouts----index-module---t-body---K3BZZ","t-small":"src-layouts----index-module---t-small---1UokR","t-heading-xs":"src-layouts----index-module---t-heading-xs---3B3tQ","t-heading-s":"src-layouts----index-module---t-heading-s---18TlJ","t-heading-m":"src-layouts----index-module---t-heading-m---kQ8nx","t-heading-l":"src-layouts----index-module---t-heading-l---1Cgwn","t-heading-xl":"src-layouts----index-module---t-heading-xl---22dSr","t-anchors":"src-layouts----index-module---t-anchors---3u-KO","t-buttons":"src-layouts----index-module---t-buttons---3Yt5T","t-buttons-large":"src-layouts----index-module---t-buttons-large---36fgE","t-formLabel":"src-layouts----index-module---t-formLabel---1kHZ7","t-formHelper":"src-layouts----index-module---t-formHelper---1Ufl4","t-formInput":"src-layouts----index-module---t-formInput---ebrbd","t-tableHeading":"src-layouts----index-module---t-tableHeading---2urvg","t-tableBody":"src-layouts----index-module---t-tableBody---2J09D","t-opaque":"src-layouts----index-module---t-opaque---2wK60","t-bold":"src-layouts----index-module---t-bold---348O1","t-italic":"src-layouts----index-module---t-italic---3bnN0","wrapper":"src-layouts----index-module---wrapper---2lZsh","contactInfoBlock":"src-layouts----index-module---contactInfoBlock---3DHFN","slideInTop":"src-layouts----index-module---slideInTop---MBeYy","slideInTopMild":"src-layouts----index-module---slideInTopMild---1NeYh","slideInBottom":"src-layouts----index-module---slideInBottom---3isG6","slideInBottomMild":"src-layouts----index-module---slideInBottomMild---1APBj","slideOutTop":"src-layouts----index-module---slideOutTop---6Lw1T","slideOutTopMild":"src-layouts----index-module---slideOutTopMild---xOJY1","slideOutBottom":"src-layouts----index-module---slideOutBottom---2piBF","slideOutBottomMild":"src-layouts----index-module---slideOutBottomMild---T_lzV","shake-horizontal":"src-layouts----index-module---shake-horizontal---X6M3C"};

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var commonlocalization = {
	  nl: {
	    bookUrl: 'https://www.micazu.nl/vakantiehuis/duitsland/eifel/kopp/ferienhaus-vulkaneifel-kopp-22798/#availability-prices',
	    contactInfoTitle: 'Contactinformatie',
	    contactFormTitle: 'Contactformulier',
	    germany: 'Duitsland',
	    metaDescription: 'Vakantiehuis in Kopp, Duitsland voor grote gezelschappen tot 25 personen.',
	    metaKeywords: 'vakantiehuis, huren, kopp, duitsland, grote, gezelschappen, personen, ardennen, dolomieten, wandelen, fietsen, mountainiken, wielrennen, motorrijden, kajakken, kayakken, kano, kanoën, kanoen'
	  },
	  de: {
	    bookUrl: 'https://www.micazu.de/ferienwohnung/deutschland/eifel/kopp/ferienhaus-vulkaneifel-kopp-22798/#availability-prices',
	    contactInfoTitle: 'Kontaktinformationen',
	    contactFormTitle: 'Kontaktformular',
	    germany: 'Deutschland',
	    metaDescription: 'Ferienhaus in Kopp, Deutschland für große Gruppen bis zu 25 Personen.',
	    metaKeywords: 'ferienhaus, mieten, hütten, deutschland, große, gruppen, menschen, ardennen, dolomiten, wandern, radfahren, mountainbiken, renradfahren, motorradfahren, kajak, kajakfahren, kanu, kanufahren'
	  },
	  en: {
	    bookUrl: 'https://www.micazu.com/vacation-rentals/germany/eifel/kopp/ferienhaus-vulkaneifel-kopp-22798/#availability-prices',
	    contactInfoTitle: 'Contact information',
	    contactFormTitle: 'Get in touch',
	    germany: 'Germany',
	    metaDescription: 'Holiday home in Kopp, Germany for large groups up to 25 people.',
	    metaKeywords: 'holiday home, rent, kopp, germany, large, groups, people, ardennes, dolomites, hiking, cycling, mountain biking, bicycle racing, motorcycling, kayaking, kayak, canoeing, canoe'
	  }
	};
	
	exports.default = commonlocalization;
	module.exports = exports['default'];

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

	'use strict';
	
	var localization = {
	  theHouse: {
	    nl: 'Het huis',
	    de: 'Das Haus',
	    en: 'The house'
	  },
	  activities: {
	    nl: 'Activiteiten',
	    de: 'Aktivitäten',
	    en: 'Activities'
	  },
	  surroundings: {
	    nl: 'Omgeving',
	    de: 'Die Umgebung',
	    en: 'Surroundings'
	  },
	  contactUs: {
	    nl: 'Contact',
	    de: 'Kontakt',
	    en: 'Contact'
	  }
	};
	
	module.exports = Object.freeze(localization);

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.cookies = undefined;
	
	var _universalCookie = __webpack_require__(387);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Cookies
	var cookies = exports.cookies = new _universalCookie2.default();

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-6bd90483c6715fbb58e0.js